module.exports = {
	"contractName": "ExperienceStore",
	"abi": [
		{
			"constant": true,
			"inputs": [],
			"name": "amountOfTokensForQuerying",
			"outputs": [
				{
					"name": "",
					"type": "uint256"
				}
			],
			"payable": false,
			"stateMutability": "view",
			"type": "function"
		},
		{
			"constant": false,
			"inputs": [
				{
					"name": "addr",
					"type": "address"
				}
			],
			"name": "approveToAddExperiences",
			"outputs": [],
			"payable": false,
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"constant": true,
			"inputs": [],
			"name": "lastExperienceId",
			"outputs": [
				{
					"name": "",
					"type": "uint256"
				}
			],
			"payable": false,
			"stateMutability": "view",
			"type": "function"
		},
		{
			"constant": false,
			"inputs": [
				{
					"name": "employeeAddr",
					"type": "address"
				},
				{
					"name": "_yearOfExperience",
					"type": "uint256"
				},
				{
					"name": "_experienceFor",
					"type": "bytes32"
				}
			],
			"name": "addExperienceToEmployee",
			"outputs": [],
			"payable": false,
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"constant": false,
			"inputs": [
				{
					"name": "experienceDetails",
					"type": "bytes32"
				},
				{
					"name": "experienceYear",
					"type": "uint256"
				}
			],
			"name": "queryExperiences",
			"outputs": [],
			"payable": false,
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"constant": true,
			"inputs": [],
			"name": "amountOfTokensForPosting",
			"outputs": [
				{
					"name": "",
					"type": "uint256"
				}
			],
			"payable": false,
			"stateMutability": "view",
			"type": "function"
		},
		{
			"constant": false,
			"inputs": [],
			"name": "setExperienceToFalse",
			"outputs": [],
			"payable": false,
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"constant": true,
			"inputs": [],
			"name": "owner",
			"outputs": [
				{
					"name": "",
					"type": "address"
				}
			],
			"payable": false,
			"stateMutability": "view",
			"type": "function"
		},
		{
			"constant": true,
			"inputs": [],
			"name": "echoLinkFoundation",
			"outputs": [
				{
					"name": "",
					"type": "address"
				}
			],
			"payable": false,
			"stateMutability": "view",
			"type": "function"
		},
		{
			"constant": true,
			"inputs": [
				{
					"name": "_experienceDetails",
					"type": "bytes32"
				},
				{
					"name": "_experienceYear",
					"type": "uint256"
				}
			],
			"name": "getExperienceResultWhenTrue",
			"outputs": [
				{
					"name": "",
					"type": "address[]"
				},
				{
					"name": "",
					"type": "address[]"
				}
			],
			"payable": false,
			"stateMutability": "view",
			"type": "function"
		},
		{
			"constant": false,
			"inputs": [
				{
					"name": "_amountOfTokensForPosting",
					"type": "uint256"
				},
				{
					"name": "_amountOfTokensForQuerying",
					"type": "uint256"
				}
			],
			"name": "setNumberOfTokens",
			"outputs": [],
			"payable": false,
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"constant": false,
			"inputs": [
				{
					"name": "newOwner",
					"type": "address"
				}
			],
			"name": "transferOwnership",
			"outputs": [],
			"payable": false,
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"inputs": [
				{
					"name": "echoLinktokenContractAddress",
					"type": "address"
				},
				{
					"name": "_echoLinkFoundation",
					"type": "address"
				}
			],
			"payable": false,
			"stateMutability": "nonpayable",
			"type": "constructor"
		},
		{
			"anonymous": false,
			"inputs": [
				{
					"indexed": false,
					"name": "_sender",
					"type": "address"
				},
				{
					"indexed": false,
					"name": "_details",
					"type": "bytes32"
				}
			],
			"name": "PostingAdded",
			"type": "event"
		},
		{
			"anonymous": false,
			"inputs": [
				{
					"indexed": false,
					"name": "_sender",
					"type": "address"
				},
				{
					"indexed": false,
					"name": "_person",
					"type": "address"
				},
				{
					"indexed": false,
					"name": "_experienceYear",
					"type": "uint256"
				}
			],
			"name": "ExperienceAdded",
			"type": "event"
		},
		{
			"anonymous": false,
			"inputs": [
				{
					"indexed": false,
					"name": "str",
					"type": "string"
				}
			],
			"name": "Executed",
			"type": "event"
		},
		{
			"anonymous": false,
			"inputs": [
				{
					"indexed": false,
					"name": "_employer",
					"type": "address"
				},
				{
					"indexed": false,
					"name": "_employee",
					"type": "address"
				},
				{
					"indexed": false,
					"name": "_experienceDetails",
					"type": "bytes32"
				},
				{
					"indexed": false,
					"name": "_year",
					"type": "uint256"
				}
			],
			"name": "ExperienceFetched",
			"type": "event"
		}
	],
	"bytecode": "0x6060604052341561000f57600080fd5b60405160408061172e83398101604052808051906020019091908051906020019091905050336000806101000a81548173ffffffffffffffffffffffffffffffffffffffff021916908373ffffffffffffffffffffffffffffffffffffffff16021790555081600560006101000a81548173ffffffffffffffffffffffffffffffffffffffff021916908373ffffffffffffffffffffffffffffffffffffffff160217905550600060028190555080600160006101000a81548173ffffffffffffffffffffffffffffffffffffffff021916908373ffffffffffffffffffffffffffffffffffffffff160217905550505061161f8061010f6000396000f3006060604052600436106100ba576000357c0100000000000000000000000000000000000000000000000000000000900463ffffffff1680630b0aeecb146100bf5780630fda34b9146100e8578063213fb6e71461012157806329ef02c21461014a5780634fcc1bd61461019957806363c0b2dd146101c9578063801b8764146101f25780638da5cb5b146102075780639ea392101461025c578063adeba704146102b1578063d56bb3761461037e578063f2fde38b146103aa575b600080fd5b34156100ca57600080fd5b6100d26103e3565b6040518082815260200191505060405180910390f35b34156100f357600080fd5b61011f600480803573ffffffffffffffffffffffffffffffffffffffff169060200190919050506103e9565b005b341561012c57600080fd5b610134610531565b6040518082815260200191505060405180910390f35b341561015557600080fd5b610197600480803573ffffffffffffffffffffffffffffffffffffffff1690602001909190803590602001909190803560001916906020019091905050610537565b005b34156101a457600080fd5b6101c76004808035600019169060200190919080359060200190919050506109a4565b005b34156101d457600080fd5b6101dc6110ed565b6040518082815260200191505060405180910390f35b34156101fd57600080fd5b6102056110f3565b005b341561021257600080fd5b61021a61120d565b604051808273ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff16815260200191505060405180910390f35b341561026757600080fd5b61026f611232565b604051808273ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff16815260200191505060405180910390f35b34156102bc57600080fd5b6102df600480803560001916906020019091908035906020019091905050611258565b604051808060200180602001838103835285818151815260200191508051906020019060200280838360005b8381101561032657808201518184015260208101905061030b565b50505050905001838103825284818151815260200191508051906020019060200280838360005b8381101561036857808201518184015260208101905061034d565b5050505090500194505050505060405180910390f35b341561038957600080fd5b6103a86004808035906020019091908035906020019091905050611433565b005b34156103b557600080fd5b6103e1600480803573ffffffffffffffffffffffffffffffffffffffff169060200190919050506114b4565b005b60045481565b6000809054906101000a900473ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff163373ffffffffffffffffffffffffffffffffffffffff1614151561044457600080fd5b600073ffffffffffffffffffffffffffffffffffffffff168173ffffffffffffffffffffffffffffffffffffffff16141580156104cb5750600660008273ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff16815260200190815260200160002060009054906101000a900460ff16155b15156104d657600080fd5b6001600660008373ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff16815260200190815260200160002060006101000a81548160ff02191690831515021790555050565b60025481565b6000600660003373ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff16815260200190815260200160002060009054906101000a900460ff1680156105955750600060035414155b80156105a45750600060045414155b15156105af57600080fd5b6002600081546001019190508190559050826007600083815260200190815260200160002060020181905550836007600083815260200190815260200160002060010160006101000a81548173ffffffffffffffffffffffffffffffffffffffff021916908373ffffffffffffffffffffffffffffffffffffffff160217905550336007600083815260200190815260200160002060000160006101000a81548173ffffffffffffffffffffffffffffffffffffffff021916908373ffffffffffffffffffffffffffffffffffffffff16021790555081600760008381526020019081526020016000206003018160001916905550600960008360001916600019168152602001908152602001600020600084815260200190815260200160002080548060010182816106e2919061158e565b9160005260206000209001600033909190916101000a81548173ffffffffffffffffffffffffffffffffffffffff021916908373ffffffffffffffffffffffffffffffffffffffff160217905550506008600083600019166000191681526020019081526020016000206000848152602001908152602001600020805480600101828161076f919061158e565b9160005260206000209001600086909190916101000a81548173ffffffffffffffffffffffffffffffffffffffff021916908373ffffffffffffffffffffffffffffffffffffffff16021790555050600560009054906101000a900473ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff166323b872dd33600160009054906101000a900473ffffffffffffffffffffffffffffffffffffffff166003546000604051602001526040518463ffffffff167c0100000000000000000000000000000000000000000000000000000000028152600401808473ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff1681526020018373ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff1681526020018281526020019350505050602060405180830381600087803b15156108e357600080fd5b6102c65a03f115156108f457600080fd5b50505060405180519050507fd36a956b6e1f0d2a2dee9fcb3f9bce3408008f7578e584518791b100bbb729dc338585604051808473ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff1681526020018373ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff168152602001828152602001935050505060405180910390a150505050565b6109ac6115ba565b6109b46115ba565b6000806000806000806000600354141580156109d35750600060045414155b15156109de57600080fd5b339450600960008b6000191660001916815260200190815260200160002060008a8152602001908152602001600020805480602002602001604051908101604052809291908181526020018280548015610a8d57602002820191906000526020600020905b8160009054906101000a900473ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff1681526020019060010190808311610a43575b50505050509750600860008b6000191660001916815260200190815260200160002060008a8152602001908152602001600020805480602002602001604051908101604052809291908181526020018280548015610b4057602002820191906000526020600020905b8160009054906101000a900473ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff1681526020019060010190808311610af6575b50505050509650865195506000861415610c9a57600560009054906101000a900473ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff166323b872dd86600160009054906101000a900473ffffffffffffffffffffffffffffffffffffffff166004546000604051602001526040518463ffffffff167c0100000000000000000000000000000000000000000000000000000000028152600401808473ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff1681526020018373ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff1681526020018281526020019350505050602060405180830381600087803b1515610c7957600080fd5b6102c65a03f11515610c8a57600080fd5b50505060405180519050506110e1565b6003600454811515610ca857fe5b0493506001600a60003373ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff16815260200190815260200160002060006101000a81548160ff021916908315150217905550600560009054906101000a900473ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff166323b872dd86600160009054906101000a900473ffffffffffffffffffffffffffffffffffffffff16876000604051602001526040518463ffffffff167c0100000000000000000000000000000000000000000000000000000000028152600401808473ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff1681526020018373ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff1681526020018281526020019350505050602060405180830381600087803b1515610e2657600080fd5b6102c65a03f11515610e3757600080fd5b50505060405180519050508584811515610e4d57fe5b0492508584811515610e5b57fe5b049150600090505b858110156110e057600560009054906101000a900473ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff166323b872dd868a84815181101515610eb857fe5b90602001906020020151866000604051602001526040518463ffffffff167c0100000000000000000000000000000000000000000000000000000000028152600401808473ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff1681526020018373ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff1681526020018281526020019350505050602060405180830381600087803b1515610f8357600080fd5b6102c65a03f11515610f9457600080fd5b5050506040518051905050600560009054906101000a900473ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff166323b872dd868984815181101515610fec57fe5b90602001906020020151856000604051602001526040518463ffffffff167c0100000000000000000000000000000000000000000000000000000000028152600401808473ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff1681526020018373ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff1681526020018281526020019350505050602060405180830381600087803b15156110b757600080fd5b6102c65a03f115156110c857600080fd5b50505060405180519050508080600101915050610e63565b5b50505050505050505050565b60035481565b600a60003373ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff16815260200190815260200160002060009054906101000a900460ff16151561114b57600080fd5b6000600a60003373ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff16815260200190815260200160002060006101000a81548160ff0219169083151502179055507f56ddf404dbd509bf03ac4f52efe205f9509d6d190ef6336fe90901993fedc67d6040518080602001828103825260178152602001807f657870657269656e63652073657420746f2066616c736500000000000000000081525060200191505060405180910390a1565b6000809054906101000a900473ffffffffffffffffffffffffffffffffffffffff1681565b600160009054906101000a900473ffffffffffffffffffffffffffffffffffffffff1681565b6112606115ba565b6112686115ba565b600a60003373ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff16815260200190815260200160002060009054906101000a900460ff1615156112c057600080fd5b600960008560001916600019168152602001908152602001600020600084815260200190815260200160002060086000866000191660001916815260200190815260200160002060008581526020019081526020016000208180548060200260200160405190810160405280929190818152602001828054801561139957602002820191906000526020600020905b8160009054906101000a900473ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff168152602001906001019080831161134f575b505050505091508080548060200260200160405190810160405280929190818152602001828054801561142157602002820191906000526020600020905b8160009054906101000a900473ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff16815260200190600101908083116113d7575b50505050509050915091509250929050565b6000809054906101000a900473ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff163373ffffffffffffffffffffffffffffffffffffffff1614151561148e57600080fd5b670de0b6b3a76400008202600381905550670de0b6b3a764000081026004819055505050565b6000809054906101000a900473ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff163373ffffffffffffffffffffffffffffffffffffffff1614151561150f57600080fd5b600073ffffffffffffffffffffffffffffffffffffffff168173ffffffffffffffffffffffffffffffffffffffff161415151561154b57600080fd5b806000806101000a81548173ffffffffffffffffffffffffffffffffffffffff021916908373ffffffffffffffffffffffffffffffffffffffff16021790555050565b8154818355818115116115b5578183600052602060002091820191016115b491906115ce565b5b505050565b602060405190810160405280600081525090565b6115f091905b808211156115ec5760008160009055506001016115d4565b5090565b905600a165627a7a72305820cbb06008923a77173ef3fa667ba35871afec00ddaea51e3b803c286a4b4183210029",
	"deployedBytecode": "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",
	"sourceMap": "106:6026:2:-;;;1968:253;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;216:10:4;208:5;;:18;;;;;;;;;;;;;;;;;;2105:28:2;2077:11;;:57;;;;;;;;;;;;;;;;;;2163:1;2144:16;:20;;;;2195:19;2174:18;;:40;;;;;;;;;;;;;;;;;;1968:253;;106:6026;;;;;;",
	"deployedSourceMap": "106:6026:2:-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;633:40;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;2590:186;;;;;;;;;;;;;;;;;;;;;;;;;;;;487:31;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;2827:1154;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;4021:1580;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;588:39;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;5952:178;;;;;;;;;;;;;;72:20:4;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;405:33:2;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;5607:339;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;23:1:-1;8:100;33:3;30:1;27:2;8:100;;;99:1;94:3;90;84:5;80:1;75:3;71;64:6;52:2;49:1;45:3;40:15;;8:100;;;12:14;3:109;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;23:1;8:100;33:3;30:1;27:2;8:100;;;99:1;94:3;90;84:5;80:1;75:3;71;64:6;52:2;49:1;45:3;40:15;;8:100;;;12:14;3:109;;;;;;;;;;;;;;;;;;;2266:265:2;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;255:121:4;;;;;;;;;;;;;;;;;;;;;;;;;;;;633:40:2;;;;:::o;2590:186::-;152:5:4;;;;;;;;;;;138:19;;:10;:19;;;130:28;;;;;;;;2688:1:2;2672:18;;:4;:18;;;;:51;;;;;2695:22;:28;2718:4;2695:28;;;;;;;;;;;;;;;;;;;;;;;;;2694:29;2672:51;2664:60;;;;;;;;2765:4;2734:22;:28;2757:4;2734:28;;;;;;;;;;;;;;;;:35;;;;;;;;;;;;;;;;;;2590:186;:::o;487:31::-;;;;:::o;2827:1154::-;3097:20;2976:22;:34;2999:10;2976:34;;;;;;;;;;;;;;;;;;;;;;;;;:67;;;;;3042:1;3014:24;;:29;;2976:67;:101;;;;;3076:1;3047:25;;:30;;2976:101;2968:110;;;;;;;;3122:16;;3120:18;;;;;;;;;;3097:41;;3259:17;3215:10;:24;3226:12;3215:24;;;;;;;;;;;:41;;:61;;;;3322:12;3286:10;:24;3297:12;3286:24;;;;;;;;;;;:33;;;:48;;;;;;;;;;;;;;;;;;3380:10;3344;:24;3355:12;3344:24;;;;;;;;;;;:33;;;:46;;;;;;;;;;;;;;;;;;3441:14;3400:10;:24;3411:12;3400:24;;;;;;;;;;;:38;;:55;;;;;;;3530:22;:38;3553:14;3530:38;;;;;;;;;;;;;;;;;:57;3569:17;3530:57;;;;;;;;;;;:74;;;;;;;;;;;:::i;:::-;;;;;;;;;;3593:10;3530:74;;;;;;;;;;;;;;;;;;;;;;;3678:22;:38;3701:14;3678:38;;;;;;;;;;;;;;;;;:57;3717:17;3678:57;;;;;;;;;;;:76;;;;;;;;;;;:::i;:::-;;;;;;;;;;3741:12;3678:76;;;;;;;;;;;;;;;;;;;;;;;3822:11;;;;;;;;;;;:24;;;3847:10;3859:18;;;;;;;;;;;3879:24;;3822:82;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;3914:60;3930:10;3942:12;3956:17;3914:60;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;2827:1154;;;;:::o;4021:1580::-;4223:31;;:::i;:::-;4264;;:::i;:::-;4305:14;4329:12;4866:22;5124:24;5255:27;5370:9;4150:1;4122:24;;:29;;:63;;;;;4184:1;4155:25;;:30;;4122:63;4114:72;;;;;;;;4344:10;4329:25;;4380:22;:41;4403:17;4380:41;;;;;;;;;;;;;;;;;:57;4422:14;4380:57;;;;;;;;;;;4364:73;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;4463:22;:41;4486:17;4463:41;;;;;;;;;;;;;;;;;:57;4505:14;4463:57;;;;;;;;;;;4447:73;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;4540:13;:20;4531:29;;4658:1;4648:6;:11;4645:950;;;4674:11;;;;;;;;;;;:24;;;4699:4;4705:18;;;;;;;;;;;4725:25;;4674:77;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;4645:950;;;4919:1;4891:25;;:29;;;;;;;;4866:54;;4962:4;4934:13;:25;4948:10;4934:25;;;;;;;;;;;;;;;;:32;;;;;;;;;;;;;;;;;;4980:11;;;;;;;;;;;:24;;;5005:4;5011:18;;;;;;;;;;;5031:14;4980:66;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;5167:6;5151:14;:23;;;;;;;;5124:50;;5301:6;5285:14;:23;;;;;;;;5255:53;;5380:1;5370:11;;5366:219;5387:6;5383:1;:10;5366:219;;;5417:11;;;;;;;;;;;:24;;;5442:4;5448:13;5462:1;5448:16;;;;;;;;;;;;;;;;;;5466;5417:66;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;5501:11;;;;;;;;;;;:24;;;5526:4;5532:13;5546:1;5532:16;;;;;;;;;;;;;;;;;;5550:19;5501:69;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;5395:3;;;;;;;5366:219;;;4645:950;4021:1580;;;;;;;;;;:::o;588:39::-;;;;:::o;5952:178::-;6009:13;:25;6023:10;6009:25;;;;;;;;;;;;;;;;;;;;;;;;;6001:34;;;;;;;;6073:5;6045:13;:25;6059:10;6045:25;;;;;;;;;;;;;;;;:33;;;;;;;;;;;;;;;;;;6088:35;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;5952:178::o;72:20:4:-;;;;;;;;;;;;;:::o;405:33:2:-;;;;;;;;;;;;;:::o;5607:339::-;5717:9;;:::i;:::-;5728;;:::i;:::-;5757:13;:25;5771:10;5757:25;;;;;;;;;;;;;;;;;;;;;;;;;5749:34;;;;;;;;5801:22;:42;5824:18;5801:42;;;;;;;;;;;;;;;;;:59;5844:15;5801:59;;;;;;;;;;;5879:22;:42;5902:18;5879:42;;;;;;;;;;;;;;;;;:59;5922:15;5879:59;;;;;;;;;;;5793:146;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;5607:339;;;;;:::o;2266:265::-;152:5:4;;;;;;;;;;;138:19;;:10;:19;;;130:28;;;;;;;;2445:6:2;2417:25;:34;2390:24;:61;;;;2518:6;2489:26;:35;2461:25;:63;;;;2266:265;;:::o;255:121:4:-;152:5;;;;;;;;;;;138:19;;:10;:19;;;130:28;;;;;;;;349:1;329:22;;:8;:22;;;;321:31;;;;;;;;364:8;356:5;;:16;;;;;;;;;;;;;;;;;;255:121;:::o;106:6026:2:-;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;;;:::o;:::-;;;;;;;;;;;;;;;:::o;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;:::o",
	"source": "pragma solidity ^0.4.16;\n\nimport './EchoLinkToken.sol';\nimport './SafeMath.sol';\nimport './Ownable.sol';\n\ncontract ExperienceStore is Ownable{\n    \n    using SafeMath for uint256;\n\n    //structure to store experience\n    struct experience{\n        address employer;\n        address employee;\n        uint256 yearOfExperience;\n        bytes32 experienceFor;\n    }\n\n    //address of _echoLinkFoundation\n    address public echoLinkFoundation;\n    //variable to store last credential ID\n    uint256 public lastExperienceId;\n    //set number of tokens to be givem for querying and posting\n    uint256 public amountOfTokensForPosting;\n    uint256 public amountOfTokensForQuerying;\n\n    //object for token contract\n    EchoLinkToken private objEchoLink;\n\n    //mapping to store approved user for credential\n    mapping(address => bool) private approvedForExperiences;\n    //mapping posting details\n    //mapping to add experience to employee by employer\n    mapping (uint256 => experience) private Experience;\n    //mapping to store address of employee corrresponding to the details of experience\n    mapping (bytes32 => mapping (uint256 => address [])) private mappingArrayOfEmployee;\n    //mapping to store address of employee corrresponding to the details of experience\n    mapping (bytes32 => mapping (uint256 => address [])) private mappingArrayOfEmployer;\n    //mapping to set true when someone is fetching experience details\n    mapping (address => bool) private experienceSet;\n\n    event PostingAdded(address _sender, bytes32 _details);\n    //fire when experience is added\n    event ExperienceAdded(address _sender, address _person, uint256 _experienceYear);\n    //fire when posting is found on query\n    event Executed(string str);\n    //fire when experience is found on query\n    event ExperienceFetched(address _employer, address _employee, bytes32 _experienceDetails, uint256 _year);\n\n    //fire when Status is found on query\n    //event StatusFetched()\n    \n    function ExperienceStore(address echoLinktokenContractAddress, address _echoLinkFoundation) public {\n        objEchoLink = EchoLinkToken(echoLinktokenContractAddress);\n        lastExperienceId = 0;\n        echoLinkFoundation = _echoLinkFoundation;\n    }\n\n    //function to set number of tokens\n    function setNumberOfTokens(uint256 _amountOfTokensForPosting, uint256 _amountOfTokensForQuerying) public onlyOwner{\n        amountOfTokensForPosting = _amountOfTokensForPosting * 10**18;\n        amountOfTokensForQuerying = _amountOfTokensForQuerying * 10**18;\n    }\n\n    //function to approve employer to add experience\n    function approveToAddExperiences(address addr) public onlyOwner {\n        require(addr != address(0) && !approvedForExperiences[addr]);\n        approvedForExperiences[addr] = true;\n    }\n\n    //function to add experience to employee\n    function addExperienceToEmployee(address employeeAddr, \n        uint256 _yearOfExperience, \n        bytes32 _experienceFor) public{\n\n        require(approvedForExperiences[msg.sender] && amountOfTokensForPosting != 0 && amountOfTokensForQuerying != 0);\n        \n        uint256 experienceId = ++lastExperienceId;\n\n        //experience is added to employee for particular employer\n        Experience[experienceId].yearOfExperience = _yearOfExperience;\n        Experience[experienceId].employee = employeeAddr;\n        Experience[experienceId].employer = msg.sender;\n        Experience[experienceId].experienceFor = _experienceFor;\n\n        //storing address of employer corrresponding to details\n        mappingArrayOfEmployer[_experienceFor][_yearOfExperience].push(msg.sender);\n        //storing address of employee corrresponding to details\n        mappingArrayOfEmployee[_experienceFor][_yearOfExperience].push(employeeAddr);\n\n        //transfer 10 EKO to echolink echoLinkFoundation\n        objEchoLink.transferFrom(msg.sender, echoLinkFoundation, amountOfTokensForPosting);\n        ExperienceAdded(msg.sender, employeeAddr, _yearOfExperience);\n    }\n\n    //search based on experiences\n    function queryExperiences(bytes32 experienceDetails, uint256 experienceYear) public{\n        require(amountOfTokensForPosting != 0 && amountOfTokensForQuerying != 0);\n        //array of address\n        address [] memory arrayEmployer;\n        address [] memory arrayEmployee;\n        uint256 length;\n        address from = msg.sender;\n        arrayEmployer = mappingArrayOfEmployer[experienceDetails][experienceYear];\n        arrayEmployee = mappingArrayOfEmployee[experienceDetails][experienceYear];\n\n        length = arrayEmployee.length;\n\n        //length of array is 0, transfer all tokens to echoLinkFoundation\n        if(length == 0){\n            objEchoLink.transferFrom(from, echoLinkFoundation, amountOfTokensForQuerying);\n        }\n        //length != 0, transfer equal amount of tokens to issuer & recipient\n        else{\n            uint256 amountTokenPay = amountOfTokensForQuerying / 3;\n            experienceSet[msg.sender] = true;\n            objEchoLink.transferFrom(from, echoLinkFoundation, amountTokenPay);\n            //calculate equal amount of token to give to issuer\n            uint256 equalTokenIssuer = amountTokenPay/(length);\n            //calculate equal amount of token to give to recepient\n            uint256 equalTokenRecepient = amountTokenPay/(length);\n            //transfer token to each issuer\n            for(uint256 i=0; i < length; i++){\n                objEchoLink.transferFrom(from, arrayEmployer[i], equalTokenIssuer);\n                objEchoLink.transferFrom(from, arrayEmployee[i], equalTokenRecepient);\n            }\n        }\n    }\n\n    function getExperienceResultWhenTrue(bytes32 _experienceDetails, uint256 _experienceYear) public view returns(address[], address[]) {\n        require(experienceSet[msg.sender]);\n        return (mappingArrayOfEmployer[_experienceDetails][_experienceYear], \n                mappingArrayOfEmployee[_experienceDetails][_experienceYear]);\n    }\n\n    function setExperienceToFalse() public {\n        require(experienceSet[msg.sender]);\n        experienceSet[msg.sender] = false;\n        Executed(\"experience set to false\");\n    }\n}",
	"sourcePath": "/Users/sarthak/dltlabs/echolink-code/contracts/ExperienceStore.sol",
	"ast": {
		"attributes": {
			"absolutePath": "/Users/sarthak/dltlabs/echolink-code/contracts/ExperienceStore.sol",
			"exportedSymbols": {
				"ExperienceStore": [
					1472
				]
			}
		},
		"children": [
			{
				"attributes": {
					"literals": [
						"solidity",
						"^",
						"0.4",
						".16"
					]
				},
				"id": 1028,
				"name": "PragmaDirective",
				"src": "0:24:2"
			},
			{
				"attributes": {
					"SourceUnit": 1027,
					"absolutePath": "/Users/sarthak/dltlabs/echolink-code/contracts/EchoLinkToken.sol",
					"file": "./EchoLinkToken.sol",
					"scope": 1473,
					"symbolAliases": [
						null
					],
					"unitAlias": ""
				},
				"id": 1029,
				"name": "ImportDirective",
				"src": "26:29:2"
			},
			{
				"attributes": {
					"SourceUnit": 1963,
					"absolutePath": "/Users/sarthak/dltlabs/echolink-code/contracts/SafeMath.sol",
					"file": "./SafeMath.sol",
					"scope": 1473,
					"symbolAliases": [
						null
					],
					"unitAlias": ""
				},
				"id": 1030,
				"name": "ImportDirective",
				"src": "56:24:2"
			},
			{
				"attributes": {
					"SourceUnit": 1575,
					"absolutePath": "/Users/sarthak/dltlabs/echolink-code/contracts/Ownable.sol",
					"file": "./Ownable.sol",
					"scope": 1473,
					"symbolAliases": [
						null
					],
					"unitAlias": ""
				},
				"id": 1031,
				"name": "ImportDirective",
				"src": "81:23:2"
			},
			{
				"attributes": {
					"contractDependencies": [
						1574
					],
					"contractKind": "contract",
					"documentation": null,
					"fullyImplemented": true,
					"linearizedBaseContracts": [
						1472,
						1574
					],
					"name": "ExperienceStore",
					"scope": 1473
				},
				"children": [
					{
						"attributes": {
							"arguments": [
								null
							]
						},
						"children": [
							{
								"attributes": {
									"contractScope": null,
									"name": "Ownable",
									"referencedDeclaration": 1574,
									"type": "contract Ownable"
								},
								"id": 1032,
								"name": "UserDefinedTypeName",
								"src": "134:7:2"
							}
						],
						"id": 1033,
						"name": "InheritanceSpecifier",
						"src": "134:7:2"
					},
					{
						"children": [
							{
								"attributes": {
									"contractScope": null,
									"name": "SafeMath",
									"referencedDeclaration": 1962,
									"type": "library SafeMath"
								},
								"id": 1034,
								"name": "UserDefinedTypeName",
								"src": "158:8:2"
							},
							{
								"attributes": {
									"name": "uint256",
									"type": "uint256"
								},
								"id": 1035,
								"name": "ElementaryTypeName",
								"src": "171:7:2"
							}
						],
						"id": 1036,
						"name": "UsingForDirective",
						"src": "152:27:2"
					},
					{
						"attributes": {
							"canonicalName": "ExperienceStore.experience",
							"name": "experience",
							"scope": 1472,
							"visibility": "public"
						},
						"children": [
							{
								"attributes": {
									"constant": false,
									"name": "employer",
									"scope": 1045,
									"stateVariable": false,
									"storageLocation": "default",
									"type": "address",
									"value": null,
									"visibility": "internal"
								},
								"children": [
									{
										"attributes": {
											"name": "address",
											"type": "address"
										},
										"id": 1037,
										"name": "ElementaryTypeName",
										"src": "248:7:2"
									}
								],
								"id": 1038,
								"name": "VariableDeclaration",
								"src": "248:16:2"
							},
							{
								"attributes": {
									"constant": false,
									"name": "employee",
									"scope": 1045,
									"stateVariable": false,
									"storageLocation": "default",
									"type": "address",
									"value": null,
									"visibility": "internal"
								},
								"children": [
									{
										"attributes": {
											"name": "address",
											"type": "address"
										},
										"id": 1039,
										"name": "ElementaryTypeName",
										"src": "274:7:2"
									}
								],
								"id": 1040,
								"name": "VariableDeclaration",
								"src": "274:16:2"
							},
							{
								"attributes": {
									"constant": false,
									"name": "yearOfExperience",
									"scope": 1045,
									"stateVariable": false,
									"storageLocation": "default",
									"type": "uint256",
									"value": null,
									"visibility": "internal"
								},
								"children": [
									{
										"attributes": {
											"name": "uint256",
											"type": "uint256"
										},
										"id": 1041,
										"name": "ElementaryTypeName",
										"src": "300:7:2"
									}
								],
								"id": 1042,
								"name": "VariableDeclaration",
								"src": "300:24:2"
							},
							{
								"attributes": {
									"constant": false,
									"name": "experienceFor",
									"scope": 1045,
									"stateVariable": false,
									"storageLocation": "default",
									"type": "bytes32",
									"value": null,
									"visibility": "internal"
								},
								"children": [
									{
										"attributes": {
											"name": "bytes32",
											"type": "bytes32"
										},
										"id": 1043,
										"name": "ElementaryTypeName",
										"src": "334:7:2"
									}
								],
								"id": 1044,
								"name": "VariableDeclaration",
								"src": "334:21:2"
							}
						],
						"id": 1045,
						"name": "StructDefinition",
						"src": "221:141:2"
					},
					{
						"attributes": {
							"constant": false,
							"name": "echoLinkFoundation",
							"scope": 1472,
							"stateVariable": true,
							"storageLocation": "default",
							"type": "address",
							"value": null,
							"visibility": "public"
						},
						"children": [
							{
								"attributes": {
									"name": "address",
									"type": "address"
								},
								"id": 1046,
								"name": "ElementaryTypeName",
								"src": "405:7:2"
							}
						],
						"id": 1047,
						"name": "VariableDeclaration",
						"src": "405:33:2"
					},
					{
						"attributes": {
							"constant": false,
							"name": "lastExperienceId",
							"scope": 1472,
							"stateVariable": true,
							"storageLocation": "default",
							"type": "uint256",
							"value": null,
							"visibility": "public"
						},
						"children": [
							{
								"attributes": {
									"name": "uint256",
									"type": "uint256"
								},
								"id": 1048,
								"name": "ElementaryTypeName",
								"src": "487:7:2"
							}
						],
						"id": 1049,
						"name": "VariableDeclaration",
						"src": "487:31:2"
					},
					{
						"attributes": {
							"constant": false,
							"name": "amountOfTokensForPosting",
							"scope": 1472,
							"stateVariable": true,
							"storageLocation": "default",
							"type": "uint256",
							"value": null,
							"visibility": "public"
						},
						"children": [
							{
								"attributes": {
									"name": "uint256",
									"type": "uint256"
								},
								"id": 1050,
								"name": "ElementaryTypeName",
								"src": "588:7:2"
							}
						],
						"id": 1051,
						"name": "VariableDeclaration",
						"src": "588:39:2"
					},
					{
						"attributes": {
							"constant": false,
							"name": "amountOfTokensForQuerying",
							"scope": 1472,
							"stateVariable": true,
							"storageLocation": "default",
							"type": "uint256",
							"value": null,
							"visibility": "public"
						},
						"children": [
							{
								"attributes": {
									"name": "uint256",
									"type": "uint256"
								},
								"id": 1052,
								"name": "ElementaryTypeName",
								"src": "633:7:2"
							}
						],
						"id": 1053,
						"name": "VariableDeclaration",
						"src": "633:40:2"
					},
					{
						"attributes": {
							"constant": false,
							"name": "objEchoLink",
							"scope": 1472,
							"stateVariable": true,
							"storageLocation": "default",
							"type": "contract EchoLinkToken",
							"value": null,
							"visibility": "private"
						},
						"children": [
							{
								"attributes": {
									"contractScope": null,
									"name": "EchoLinkToken",
									"referencedDeclaration": 1026,
									"type": "contract EchoLinkToken"
								},
								"id": 1054,
								"name": "UserDefinedTypeName",
								"src": "712:13:2"
							}
						],
						"id": 1055,
						"name": "VariableDeclaration",
						"src": "712:33:2"
					},
					{
						"attributes": {
							"constant": false,
							"name": "approvedForExperiences",
							"scope": 1472,
							"stateVariable": true,
							"storageLocation": "default",
							"type": "mapping(address => bool)",
							"value": null,
							"visibility": "private"
						},
						"children": [
							{
								"attributes": {
									"type": "mapping(address => bool)"
								},
								"children": [
									{
										"attributes": {
											"name": "address",
											"type": "address"
										},
										"id": 1056,
										"name": "ElementaryTypeName",
										"src": "812:7:2"
									},
									{
										"attributes": {
											"name": "bool",
											"type": "bool"
										},
										"id": 1057,
										"name": "ElementaryTypeName",
										"src": "823:4:2"
									}
								],
								"id": 1058,
								"name": "Mapping",
								"src": "804:24:2"
							}
						],
						"id": 1059,
						"name": "VariableDeclaration",
						"src": "804:55:2"
					},
					{
						"attributes": {
							"constant": false,
							"name": "Experience",
							"scope": 1472,
							"stateVariable": true,
							"storageLocation": "default",
							"type": "mapping(uint256 => struct ExperienceStore.experience storage ref)",
							"value": null,
							"visibility": "private"
						},
						"children": [
							{
								"attributes": {
									"type": "mapping(uint256 => struct ExperienceStore.experience storage ref)"
								},
								"children": [
									{
										"attributes": {
											"name": "uint256",
											"type": "uint256"
										},
										"id": 1060,
										"name": "ElementaryTypeName",
										"src": "960:7:2"
									},
									{
										"attributes": {
											"contractScope": null,
											"name": "experience",
											"referencedDeclaration": 1045,
											"type": "struct ExperienceStore.experience storage pointer"
										},
										"id": 1061,
										"name": "UserDefinedTypeName",
										"src": "971:10:2"
									}
								],
								"id": 1062,
								"name": "Mapping",
								"src": "951:31:2"
							}
						],
						"id": 1063,
						"name": "VariableDeclaration",
						"src": "951:50:2"
					},
					{
						"attributes": {
							"constant": false,
							"name": "mappingArrayOfEmployee",
							"scope": 1472,
							"stateVariable": true,
							"storageLocation": "default",
							"type": "mapping(bytes32 => mapping(uint256 => address[] storage ref))",
							"value": null,
							"visibility": "private"
						},
						"children": [
							{
								"attributes": {
									"type": "mapping(bytes32 => mapping(uint256 => address[] storage ref))"
								},
								"children": [
									{
										"attributes": {
											"name": "bytes32",
											"type": "bytes32"
										},
										"id": 1064,
										"name": "ElementaryTypeName",
										"src": "1103:7:2"
									},
									{
										"attributes": {
											"type": "mapping(uint256 => address[] storage ref)"
										},
										"children": [
											{
												"attributes": {
													"name": "uint256",
													"type": "uint256"
												},
												"id": 1065,
												"name": "ElementaryTypeName",
												"src": "1123:7:2"
											},
											{
												"attributes": {
													"length": null,
													"type": "address[] storage pointer"
												},
												"children": [
													{
														"attributes": {
															"name": "address",
															"type": "address"
														},
														"id": 1066,
														"name": "ElementaryTypeName",
														"src": "1134:7:2"
													}
												],
												"id": 1067,
												"name": "ArrayTypeName",
												"src": "1134:10:2"
											}
										],
										"id": 1068,
										"name": "Mapping",
										"src": "1114:31:2"
									}
								],
								"id": 1069,
								"name": "Mapping",
								"src": "1094:52:2"
							}
						],
						"id": 1070,
						"name": "VariableDeclaration",
						"src": "1094:83:2"
					},
					{
						"attributes": {
							"constant": false,
							"name": "mappingArrayOfEmployer",
							"scope": 1472,
							"stateVariable": true,
							"storageLocation": "default",
							"type": "mapping(bytes32 => mapping(uint256 => address[] storage ref))",
							"value": null,
							"visibility": "private"
						},
						"children": [
							{
								"attributes": {
									"type": "mapping(bytes32 => mapping(uint256 => address[] storage ref))"
								},
								"children": [
									{
										"attributes": {
											"name": "bytes32",
											"type": "bytes32"
										},
										"id": 1071,
										"name": "ElementaryTypeName",
										"src": "1279:7:2"
									},
									{
										"attributes": {
											"type": "mapping(uint256 => address[] storage ref)"
										},
										"children": [
											{
												"attributes": {
													"name": "uint256",
													"type": "uint256"
												},
												"id": 1072,
												"name": "ElementaryTypeName",
												"src": "1299:7:2"
											},
											{
												"attributes": {
													"length": null,
													"type": "address[] storage pointer"
												},
												"children": [
													{
														"attributes": {
															"name": "address",
															"type": "address"
														},
														"id": 1073,
														"name": "ElementaryTypeName",
														"src": "1310:7:2"
													}
												],
												"id": 1074,
												"name": "ArrayTypeName",
												"src": "1310:10:2"
											}
										],
										"id": 1075,
										"name": "Mapping",
										"src": "1290:31:2"
									}
								],
								"id": 1076,
								"name": "Mapping",
								"src": "1270:52:2"
							}
						],
						"id": 1077,
						"name": "VariableDeclaration",
						"src": "1270:83:2"
					},
					{
						"attributes": {
							"constant": false,
							"name": "experienceSet",
							"scope": 1472,
							"stateVariable": true,
							"storageLocation": "default",
							"type": "mapping(address => bool)",
							"value": null,
							"visibility": "private"
						},
						"children": [
							{
								"attributes": {
									"type": "mapping(address => bool)"
								},
								"children": [
									{
										"attributes": {
											"name": "address",
											"type": "address"
										},
										"id": 1078,
										"name": "ElementaryTypeName",
										"src": "1438:7:2"
									},
									{
										"attributes": {
											"name": "bool",
											"type": "bool"
										},
										"id": 1079,
										"name": "ElementaryTypeName",
										"src": "1449:4:2"
									}
								],
								"id": 1080,
								"name": "Mapping",
								"src": "1429:25:2"
							}
						],
						"id": 1081,
						"name": "VariableDeclaration",
						"src": "1429:47:2"
					},
					{
						"attributes": {
							"anonymous": false,
							"name": "PostingAdded"
						},
						"children": [
							{
								"children": [
									{
										"attributes": {
											"constant": false,
											"indexed": false,
											"name": "_sender",
											"scope": 1087,
											"stateVariable": false,
											"storageLocation": "default",
											"type": "address",
											"value": null,
											"visibility": "internal"
										},
										"children": [
											{
												"attributes": {
													"name": "address",
													"type": "address"
												},
												"id": 1082,
												"name": "ElementaryTypeName",
												"src": "1502:7:2"
											}
										],
										"id": 1083,
										"name": "VariableDeclaration",
										"src": "1502:15:2"
									},
									{
										"attributes": {
											"constant": false,
											"indexed": false,
											"name": "_details",
											"scope": 1087,
											"stateVariable": false,
											"storageLocation": "default",
											"type": "bytes32",
											"value": null,
											"visibility": "internal"
										},
										"children": [
											{
												"attributes": {
													"name": "bytes32",
													"type": "bytes32"
												},
												"id": 1084,
												"name": "ElementaryTypeName",
												"src": "1519:7:2"
											}
										],
										"id": 1085,
										"name": "VariableDeclaration",
										"src": "1519:16:2"
									}
								],
								"id": 1086,
								"name": "ParameterList",
								"src": "1501:35:2"
							}
						],
						"id": 1087,
						"name": "EventDefinition",
						"src": "1483:54:2"
					},
					{
						"attributes": {
							"anonymous": false,
							"name": "ExperienceAdded"
						},
						"children": [
							{
								"children": [
									{
										"attributes": {
											"constant": false,
											"indexed": false,
											"name": "_sender",
											"scope": 1095,
											"stateVariable": false,
											"storageLocation": "default",
											"type": "address",
											"value": null,
											"visibility": "internal"
										},
										"children": [
											{
												"attributes": {
													"name": "address",
													"type": "address"
												},
												"id": 1088,
												"name": "ElementaryTypeName",
												"src": "1600:7:2"
											}
										],
										"id": 1089,
										"name": "VariableDeclaration",
										"src": "1600:15:2"
									},
									{
										"attributes": {
											"constant": false,
											"indexed": false,
											"name": "_person",
											"scope": 1095,
											"stateVariable": false,
											"storageLocation": "default",
											"type": "address",
											"value": null,
											"visibility": "internal"
										},
										"children": [
											{
												"attributes": {
													"name": "address",
													"type": "address"
												},
												"id": 1090,
												"name": "ElementaryTypeName",
												"src": "1617:7:2"
											}
										],
										"id": 1091,
										"name": "VariableDeclaration",
										"src": "1617:15:2"
									},
									{
										"attributes": {
											"constant": false,
											"indexed": false,
											"name": "_experienceYear",
											"scope": 1095,
											"stateVariable": false,
											"storageLocation": "default",
											"type": "uint256",
											"value": null,
											"visibility": "internal"
										},
										"children": [
											{
												"attributes": {
													"name": "uint256",
													"type": "uint256"
												},
												"id": 1092,
												"name": "ElementaryTypeName",
												"src": "1634:7:2"
											}
										],
										"id": 1093,
										"name": "VariableDeclaration",
										"src": "1634:23:2"
									}
								],
								"id": 1094,
								"name": "ParameterList",
								"src": "1599:59:2"
							}
						],
						"id": 1095,
						"name": "EventDefinition",
						"src": "1578:81:2"
					},
					{
						"attributes": {
							"anonymous": false,
							"name": "Executed"
						},
						"children": [
							{
								"children": [
									{
										"attributes": {
											"constant": false,
											"indexed": false,
											"name": "str",
											"scope": 1099,
											"stateVariable": false,
											"storageLocation": "default",
											"type": "string memory",
											"value": null,
											"visibility": "internal"
										},
										"children": [
											{
												"attributes": {
													"name": "string",
													"type": "string storage pointer"
												},
												"id": 1096,
												"name": "ElementaryTypeName",
												"src": "1721:6:2"
											}
										],
										"id": 1097,
										"name": "VariableDeclaration",
										"src": "1721:10:2"
									}
								],
								"id": 1098,
								"name": "ParameterList",
								"src": "1720:12:2"
							}
						],
						"id": 1099,
						"name": "EventDefinition",
						"src": "1706:27:2"
					},
					{
						"attributes": {
							"anonymous": false,
							"name": "ExperienceFetched"
						},
						"children": [
							{
								"children": [
									{
										"attributes": {
											"constant": false,
											"indexed": false,
											"name": "_employer",
											"scope": 1109,
											"stateVariable": false,
											"storageLocation": "default",
											"type": "address",
											"value": null,
											"visibility": "internal"
										},
										"children": [
											{
												"attributes": {
													"name": "address",
													"type": "address"
												},
												"id": 1100,
												"name": "ElementaryTypeName",
												"src": "1807:7:2"
											}
										],
										"id": 1101,
										"name": "VariableDeclaration",
										"src": "1807:17:2"
									},
									{
										"attributes": {
											"constant": false,
											"indexed": false,
											"name": "_employee",
											"scope": 1109,
											"stateVariable": false,
											"storageLocation": "default",
											"type": "address",
											"value": null,
											"visibility": "internal"
										},
										"children": [
											{
												"attributes": {
													"name": "address",
													"type": "address"
												},
												"id": 1102,
												"name": "ElementaryTypeName",
												"src": "1826:7:2"
											}
										],
										"id": 1103,
										"name": "VariableDeclaration",
										"src": "1826:17:2"
									},
									{
										"attributes": {
											"constant": false,
											"indexed": false,
											"name": "_experienceDetails",
											"scope": 1109,
											"stateVariable": false,
											"storageLocation": "default",
											"type": "bytes32",
											"value": null,
											"visibility": "internal"
										},
										"children": [
											{
												"attributes": {
													"name": "bytes32",
													"type": "bytes32"
												},
												"id": 1104,
												"name": "ElementaryTypeName",
												"src": "1845:7:2"
											}
										],
										"id": 1105,
										"name": "VariableDeclaration",
										"src": "1845:26:2"
									},
									{
										"attributes": {
											"constant": false,
											"indexed": false,
											"name": "_year",
											"scope": 1109,
											"stateVariable": false,
											"storageLocation": "default",
											"type": "uint256",
											"value": null,
											"visibility": "internal"
										},
										"children": [
											{
												"attributes": {
													"name": "uint256",
													"type": "uint256"
												},
												"id": 1106,
												"name": "ElementaryTypeName",
												"src": "1873:7:2"
											}
										],
										"id": 1107,
										"name": "VariableDeclaration",
										"src": "1873:13:2"
									}
								],
								"id": 1108,
								"name": "ParameterList",
								"src": "1806:81:2"
							}
						],
						"id": 1109,
						"name": "EventDefinition",
						"src": "1783:105:2"
					},
					{
						"attributes": {
							"constant": false,
							"implemented": true,
							"isConstructor": true,
							"modifiers": [
								null
							],
							"name": "ExperienceStore",
							"payable": false,
							"scope": 1472,
							"stateMutability": "nonpayable",
							"superFunction": null,
							"visibility": "public"
						},
						"children": [
							{
								"children": [
									{
										"attributes": {
											"constant": false,
											"name": "echoLinktokenContractAddress",
											"scope": 1131,
											"stateVariable": false,
											"storageLocation": "default",
											"type": "address",
											"value": null,
											"visibility": "internal"
										},
										"children": [
											{
												"attributes": {
													"name": "address",
													"type": "address"
												},
												"id": 1110,
												"name": "ElementaryTypeName",
												"src": "1993:7:2"
											}
										],
										"id": 1111,
										"name": "VariableDeclaration",
										"src": "1993:36:2"
									},
									{
										"attributes": {
											"constant": false,
											"name": "_echoLinkFoundation",
											"scope": 1131,
											"stateVariable": false,
											"storageLocation": "default",
											"type": "address",
											"value": null,
											"visibility": "internal"
										},
										"children": [
											{
												"attributes": {
													"name": "address",
													"type": "address"
												},
												"id": 1112,
												"name": "ElementaryTypeName",
												"src": "2031:7:2"
											}
										],
										"id": 1113,
										"name": "VariableDeclaration",
										"src": "2031:27:2"
									}
								],
								"id": 1114,
								"name": "ParameterList",
								"src": "1992:67:2"
							},
							{
								"attributes": {
									"parameters": [
										null
									]
								},
								"children": [],
								"id": 1115,
								"name": "ParameterList",
								"src": "2067:0:2"
							},
							{
								"children": [
									{
										"children": [
											{
												"attributes": {
													"argumentTypes": null,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"operator": "=",
													"type": "contract EchoLinkToken"
												},
												"children": [
													{
														"attributes": {
															"argumentTypes": null,
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 1055,
															"type": "contract EchoLinkToken",
															"value": "objEchoLink"
														},
														"id": 1116,
														"name": "Identifier",
														"src": "2077:11:2"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"isStructConstructorCall": false,
															"lValueRequested": false,
															"names": [
																null
															],
															"type": "contract EchoLinkToken",
															"type_conversion": true
														},
														"children": [
															{
																"attributes": {
																	"argumentTypes": [
																		{
																			"typeIdentifier": "t_address",
																			"typeString": "address"
																		}
																	],
																	"overloadedDeclarations": [
																		null
																	],
																	"referencedDeclaration": 1026,
																	"type": "type(contract EchoLinkToken)",
																	"value": "EchoLinkToken"
																},
																"id": 1117,
																"name": "Identifier",
																"src": "2091:13:2"
															},
															{
																"attributes": {
																	"argumentTypes": null,
																	"overloadedDeclarations": [
																		null
																	],
																	"referencedDeclaration": 1111,
																	"type": "address",
																	"value": "echoLinktokenContractAddress"
																},
																"id": 1118,
																"name": "Identifier",
																"src": "2105:28:2"
															}
														],
														"id": 1119,
														"name": "FunctionCall",
														"src": "2091:43:2"
													}
												],
												"id": 1120,
												"name": "Assignment",
												"src": "2077:57:2"
											}
										],
										"id": 1121,
										"name": "ExpressionStatement",
										"src": "2077:57:2"
									},
									{
										"children": [
											{
												"attributes": {
													"argumentTypes": null,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"operator": "=",
													"type": "uint256"
												},
												"children": [
													{
														"attributes": {
															"argumentTypes": null,
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 1049,
															"type": "uint256",
															"value": "lastExperienceId"
														},
														"id": 1122,
														"name": "Identifier",
														"src": "2144:16:2"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"hexvalue": "30",
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"subdenomination": null,
															"token": "number",
															"type": "int_const 0",
															"value": "0"
														},
														"id": 1123,
														"name": "Literal",
														"src": "2163:1:2"
													}
												],
												"id": 1124,
												"name": "Assignment",
												"src": "2144:20:2"
											}
										],
										"id": 1125,
										"name": "ExpressionStatement",
										"src": "2144:20:2"
									},
									{
										"children": [
											{
												"attributes": {
													"argumentTypes": null,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"operator": "=",
													"type": "address"
												},
												"children": [
													{
														"attributes": {
															"argumentTypes": null,
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 1047,
															"type": "address",
															"value": "echoLinkFoundation"
														},
														"id": 1126,
														"name": "Identifier",
														"src": "2174:18:2"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 1113,
															"type": "address",
															"value": "_echoLinkFoundation"
														},
														"id": 1127,
														"name": "Identifier",
														"src": "2195:19:2"
													}
												],
												"id": 1128,
												"name": "Assignment",
												"src": "2174:40:2"
											}
										],
										"id": 1129,
										"name": "ExpressionStatement",
										"src": "2174:40:2"
									}
								],
								"id": 1130,
								"name": "Block",
								"src": "2067:154:2"
							}
						],
						"id": 1131,
						"name": "FunctionDefinition",
						"src": "1968:253:2"
					},
					{
						"attributes": {
							"constant": false,
							"implemented": true,
							"isConstructor": false,
							"name": "setNumberOfTokens",
							"payable": false,
							"scope": 1472,
							"stateMutability": "nonpayable",
							"superFunction": null,
							"visibility": "public"
						},
						"children": [
							{
								"children": [
									{
										"attributes": {
											"constant": false,
											"name": "_amountOfTokensForPosting",
											"scope": 1157,
											"stateVariable": false,
											"storageLocation": "default",
											"type": "uint256",
											"value": null,
											"visibility": "internal"
										},
										"children": [
											{
												"attributes": {
													"name": "uint256",
													"type": "uint256"
												},
												"id": 1132,
												"name": "ElementaryTypeName",
												"src": "2293:7:2"
											}
										],
										"id": 1133,
										"name": "VariableDeclaration",
										"src": "2293:33:2"
									},
									{
										"attributes": {
											"constant": false,
											"name": "_amountOfTokensForQuerying",
											"scope": 1157,
											"stateVariable": false,
											"storageLocation": "default",
											"type": "uint256",
											"value": null,
											"visibility": "internal"
										},
										"children": [
											{
												"attributes": {
													"name": "uint256",
													"type": "uint256"
												},
												"id": 1134,
												"name": "ElementaryTypeName",
												"src": "2328:7:2"
											}
										],
										"id": 1135,
										"name": "VariableDeclaration",
										"src": "2328:34:2"
									}
								],
								"id": 1136,
								"name": "ParameterList",
								"src": "2292:71:2"
							},
							{
								"attributes": {
									"parameters": [
										null
									]
								},
								"children": [],
								"id": 1139,
								"name": "ParameterList",
								"src": "2380:0:2"
							},
							{
								"attributes": {
									"arguments": [
										null
									]
								},
								"children": [
									{
										"attributes": {
											"argumentTypes": null,
											"overloadedDeclarations": [
												null
											],
											"referencedDeclaration": 1544,
											"type": "modifier ()",
											"value": "onlyOwner"
										},
										"id": 1137,
										"name": "Identifier",
										"src": "2371:9:2"
									}
								],
								"id": 1138,
								"name": "ModifierInvocation",
								"src": "2371:9:2"
							},
							{
								"children": [
									{
										"children": [
											{
												"attributes": {
													"argumentTypes": null,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"operator": "=",
													"type": "uint256"
												},
												"children": [
													{
														"attributes": {
															"argumentTypes": null,
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 1051,
															"type": "uint256",
															"value": "amountOfTokensForPosting"
														},
														"id": 1140,
														"name": "Identifier",
														"src": "2390:24:2"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"commonType": {
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															},
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"operator": "*",
															"type": "uint256"
														},
														"children": [
															{
																"attributes": {
																	"argumentTypes": null,
																	"overloadedDeclarations": [
																		null
																	],
																	"referencedDeclaration": 1133,
																	"type": "uint256",
																	"value": "_amountOfTokensForPosting"
																},
																"id": 1141,
																"name": "Identifier",
																"src": "2417:25:2"
															},
															{
																"attributes": {
																	"argumentTypes": null,
																	"commonType": {
																		"typeIdentifier": "t_rational_1000000000000000000_by_1",
																		"typeString": "int_const 1000000000000000000"
																	},
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": true,
																	"lValueRequested": false,
																	"operator": "**",
																	"type": "int_const 1000000000000000000"
																},
																"children": [
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"hexvalue": "3130",
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": true,
																			"lValueRequested": false,
																			"subdenomination": null,
																			"token": "number",
																			"type": "int_const 10",
																			"value": "10"
																		},
																		"id": 1142,
																		"name": "Literal",
																		"src": "2445:2:2"
																	},
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"hexvalue": "3138",
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": true,
																			"lValueRequested": false,
																			"subdenomination": null,
																			"token": "number",
																			"type": "int_const 18",
																			"value": "18"
																		},
																		"id": 1143,
																		"name": "Literal",
																		"src": "2449:2:2"
																	}
																],
																"id": 1144,
																"name": "BinaryOperation",
																"src": "2445:6:2"
															}
														],
														"id": 1145,
														"name": "BinaryOperation",
														"src": "2417:34:2"
													}
												],
												"id": 1146,
												"name": "Assignment",
												"src": "2390:61:2"
											}
										],
										"id": 1147,
										"name": "ExpressionStatement",
										"src": "2390:61:2"
									},
									{
										"children": [
											{
												"attributes": {
													"argumentTypes": null,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"operator": "=",
													"type": "uint256"
												},
												"children": [
													{
														"attributes": {
															"argumentTypes": null,
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 1053,
															"type": "uint256",
															"value": "amountOfTokensForQuerying"
														},
														"id": 1148,
														"name": "Identifier",
														"src": "2461:25:2"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"commonType": {
																"typeIdentifier": "t_uint256",
																"typeString": "uint256"
															},
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"operator": "*",
															"type": "uint256"
														},
														"children": [
															{
																"attributes": {
																	"argumentTypes": null,
																	"overloadedDeclarations": [
																		null
																	],
																	"referencedDeclaration": 1135,
																	"type": "uint256",
																	"value": "_amountOfTokensForQuerying"
																},
																"id": 1149,
																"name": "Identifier",
																"src": "2489:26:2"
															},
															{
																"attributes": {
																	"argumentTypes": null,
																	"commonType": {
																		"typeIdentifier": "t_rational_1000000000000000000_by_1",
																		"typeString": "int_const 1000000000000000000"
																	},
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": true,
																	"lValueRequested": false,
																	"operator": "**",
																	"type": "int_const 1000000000000000000"
																},
																"children": [
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"hexvalue": "3130",
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": true,
																			"lValueRequested": false,
																			"subdenomination": null,
																			"token": "number",
																			"type": "int_const 10",
																			"value": "10"
																		},
																		"id": 1150,
																		"name": "Literal",
																		"src": "2518:2:2"
																	},
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"hexvalue": "3138",
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": true,
																			"lValueRequested": false,
																			"subdenomination": null,
																			"token": "number",
																			"type": "int_const 18",
																			"value": "18"
																		},
																		"id": 1151,
																		"name": "Literal",
																		"src": "2522:2:2"
																	}
																],
																"id": 1152,
																"name": "BinaryOperation",
																"src": "2518:6:2"
															}
														],
														"id": 1153,
														"name": "BinaryOperation",
														"src": "2489:35:2"
													}
												],
												"id": 1154,
												"name": "Assignment",
												"src": "2461:63:2"
											}
										],
										"id": 1155,
										"name": "ExpressionStatement",
										"src": "2461:63:2"
									}
								],
								"id": 1156,
								"name": "Block",
								"src": "2380:151:2"
							}
						],
						"id": 1157,
						"name": "FunctionDefinition",
						"src": "2266:265:2"
					},
					{
						"attributes": {
							"constant": false,
							"implemented": true,
							"isConstructor": false,
							"name": "approveToAddExperiences",
							"payable": false,
							"scope": 1472,
							"stateMutability": "nonpayable",
							"superFunction": null,
							"visibility": "public"
						},
						"children": [
							{
								"children": [
									{
										"attributes": {
											"constant": false,
											"name": "addr",
											"scope": 1184,
											"stateVariable": false,
											"storageLocation": "default",
											"type": "address",
											"value": null,
											"visibility": "internal"
										},
										"children": [
											{
												"attributes": {
													"name": "address",
													"type": "address"
												},
												"id": 1158,
												"name": "ElementaryTypeName",
												"src": "2623:7:2"
											}
										],
										"id": 1159,
										"name": "VariableDeclaration",
										"src": "2623:12:2"
									}
								],
								"id": 1160,
								"name": "ParameterList",
								"src": "2622:14:2"
							},
							{
								"attributes": {
									"parameters": [
										null
									]
								},
								"children": [],
								"id": 1163,
								"name": "ParameterList",
								"src": "2654:0:2"
							},
							{
								"attributes": {
									"arguments": [
										null
									]
								},
								"children": [
									{
										"attributes": {
											"argumentTypes": null,
											"overloadedDeclarations": [
												null
											],
											"referencedDeclaration": 1544,
											"type": "modifier ()",
											"value": "onlyOwner"
										},
										"id": 1161,
										"name": "Identifier",
										"src": "2644:9:2"
									}
								],
								"id": 1162,
								"name": "ModifierInvocation",
								"src": "2644:9:2"
							},
							{
								"children": [
									{
										"children": [
											{
												"attributes": {
													"argumentTypes": null,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"isStructConstructorCall": false,
													"lValueRequested": false,
													"names": [
														null
													],
													"type": "tuple()",
													"type_conversion": false
												},
												"children": [
													{
														"attributes": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_bool",
																	"typeString": "bool"
																}
															],
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 1977,
															"type": "function (bool) pure",
															"value": "require"
														},
														"id": 1164,
														"name": "Identifier",
														"src": "2664:7:2"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"commonType": {
																"typeIdentifier": "t_bool",
																"typeString": "bool"
															},
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"operator": "&&",
															"type": "bool"
														},
														"children": [
															{
																"attributes": {
																	"argumentTypes": null,
																	"commonType": {
																		"typeIdentifier": "t_address",
																		"typeString": "address"
																	},
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"lValueRequested": false,
																	"operator": "!=",
																	"type": "bool"
																},
																"children": [
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"overloadedDeclarations": [
																				null
																			],
																			"referencedDeclaration": 1159,
																			"type": "address",
																			"value": "addr"
																		},
																		"id": 1165,
																		"name": "Identifier",
																		"src": "2672:4:2"
																	},
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": true,
																			"isStructConstructorCall": false,
																			"lValueRequested": false,
																			"names": [
																				null
																			],
																			"type": "address",
																			"type_conversion": true
																		},
																		"children": [
																			{
																				"attributes": {
																					"argumentTypes": [
																						{
																							"typeIdentifier": "t_rational_0_by_1",
																							"typeString": "int_const 0"
																						}
																					],
																					"isConstant": false,
																					"isLValue": false,
																					"isPure": true,
																					"lValueRequested": false,
																					"type": "type(address)",
																					"value": "address"
																				},
																				"id": 1166,
																				"name": "ElementaryTypeNameExpression",
																				"src": "2680:7:2"
																			},
																			{
																				"attributes": {
																					"argumentTypes": null,
																					"hexvalue": "30",
																					"isConstant": false,
																					"isLValue": false,
																					"isPure": true,
																					"lValueRequested": false,
																					"subdenomination": null,
																					"token": "number",
																					"type": "int_const 0",
																					"value": "0"
																				},
																				"id": 1167,
																				"name": "Literal",
																				"src": "2688:1:2"
																			}
																		],
																		"id": 1168,
																		"name": "FunctionCall",
																		"src": "2680:10:2"
																	}
																],
																"id": 1169,
																"name": "BinaryOperation",
																"src": "2672:18:2"
															},
															{
																"attributes": {
																	"argumentTypes": null,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"lValueRequested": false,
																	"operator": "!",
																	"prefix": true,
																	"type": "bool"
																},
																"children": [
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"isConstant": false,
																			"isLValue": true,
																			"isPure": false,
																			"lValueRequested": false,
																			"type": "bool"
																		},
																		"children": [
																			{
																				"attributes": {
																					"argumentTypes": null,
																					"overloadedDeclarations": [
																						null
																					],
																					"referencedDeclaration": 1059,
																					"type": "mapping(address => bool)",
																					"value": "approvedForExperiences"
																				},
																				"id": 1170,
																				"name": "Identifier",
																				"src": "2695:22:2"
																			},
																			{
																				"attributes": {
																					"argumentTypes": null,
																					"overloadedDeclarations": [
																						null
																					],
																					"referencedDeclaration": 1159,
																					"type": "address",
																					"value": "addr"
																				},
																				"id": 1171,
																				"name": "Identifier",
																				"src": "2718:4:2"
																			}
																		],
																		"id": 1172,
																		"name": "IndexAccess",
																		"src": "2695:28:2"
																	}
																],
																"id": 1173,
																"name": "UnaryOperation",
																"src": "2694:29:2"
															}
														],
														"id": 1174,
														"name": "BinaryOperation",
														"src": "2672:51:2"
													}
												],
												"id": 1175,
												"name": "FunctionCall",
												"src": "2664:60:2"
											}
										],
										"id": 1176,
										"name": "ExpressionStatement",
										"src": "2664:60:2"
									},
									{
										"children": [
											{
												"attributes": {
													"argumentTypes": null,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"operator": "=",
													"type": "bool"
												},
												"children": [
													{
														"attributes": {
															"argumentTypes": null,
															"isConstant": false,
															"isLValue": true,
															"isPure": false,
															"lValueRequested": true,
															"type": "bool"
														},
														"children": [
															{
																"attributes": {
																	"argumentTypes": null,
																	"overloadedDeclarations": [
																		null
																	],
																	"referencedDeclaration": 1059,
																	"type": "mapping(address => bool)",
																	"value": "approvedForExperiences"
																},
																"id": 1177,
																"name": "Identifier",
																"src": "2734:22:2"
															},
															{
																"attributes": {
																	"argumentTypes": null,
																	"overloadedDeclarations": [
																		null
																	],
																	"referencedDeclaration": 1159,
																	"type": "address",
																	"value": "addr"
																},
																"id": 1178,
																"name": "Identifier",
																"src": "2757:4:2"
															}
														],
														"id": 1179,
														"name": "IndexAccess",
														"src": "2734:28:2"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"hexvalue": "74727565",
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"subdenomination": null,
															"token": "bool",
															"type": "bool",
															"value": "true"
														},
														"id": 1180,
														"name": "Literal",
														"src": "2765:4:2"
													}
												],
												"id": 1181,
												"name": "Assignment",
												"src": "2734:35:2"
											}
										],
										"id": 1182,
										"name": "ExpressionStatement",
										"src": "2734:35:2"
									}
								],
								"id": 1183,
								"name": "Block",
								"src": "2654:122:2"
							}
						],
						"id": 1184,
						"name": "FunctionDefinition",
						"src": "2590:186:2"
					},
					{
						"attributes": {
							"constant": false,
							"implemented": true,
							"isConstructor": false,
							"modifiers": [
								null
							],
							"name": "addExperienceToEmployee",
							"payable": false,
							"scope": 1472,
							"stateMutability": "nonpayable",
							"superFunction": null,
							"visibility": "public"
						},
						"children": [
							{
								"children": [
									{
										"attributes": {
											"constant": false,
											"name": "employeeAddr",
											"scope": 1278,
											"stateVariable": false,
											"storageLocation": "default",
											"type": "address",
											"value": null,
											"visibility": "internal"
										},
										"children": [
											{
												"attributes": {
													"name": "address",
													"type": "address"
												},
												"id": 1185,
												"name": "ElementaryTypeName",
												"src": "2860:7:2"
											}
										],
										"id": 1186,
										"name": "VariableDeclaration",
										"src": "2860:20:2"
									},
									{
										"attributes": {
											"constant": false,
											"name": "_yearOfExperience",
											"scope": 1278,
											"stateVariable": false,
											"storageLocation": "default",
											"type": "uint256",
											"value": null,
											"visibility": "internal"
										},
										"children": [
											{
												"attributes": {
													"name": "uint256",
													"type": "uint256"
												},
												"id": 1187,
												"name": "ElementaryTypeName",
												"src": "2891:7:2"
											}
										],
										"id": 1188,
										"name": "VariableDeclaration",
										"src": "2891:25:2"
									},
									{
										"attributes": {
											"constant": false,
											"name": "_experienceFor",
											"scope": 1278,
											"stateVariable": false,
											"storageLocation": "default",
											"type": "bytes32",
											"value": null,
											"visibility": "internal"
										},
										"children": [
											{
												"attributes": {
													"name": "bytes32",
													"type": "bytes32"
												},
												"id": 1189,
												"name": "ElementaryTypeName",
												"src": "2927:7:2"
											}
										],
										"id": 1190,
										"name": "VariableDeclaration",
										"src": "2927:22:2"
									}
								],
								"id": 1191,
								"name": "ParameterList",
								"src": "2859:91:2"
							},
							{
								"attributes": {
									"parameters": [
										null
									]
								},
								"children": [],
								"id": 1192,
								"name": "ParameterList",
								"src": "2957:0:2"
							},
							{
								"children": [
									{
										"children": [
											{
												"attributes": {
													"argumentTypes": null,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"isStructConstructorCall": false,
													"lValueRequested": false,
													"names": [
														null
													],
													"type": "tuple()",
													"type_conversion": false
												},
												"children": [
													{
														"attributes": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_bool",
																	"typeString": "bool"
																}
															],
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 1977,
															"type": "function (bool) pure",
															"value": "require"
														},
														"id": 1193,
														"name": "Identifier",
														"src": "2968:7:2"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"commonType": {
																"typeIdentifier": "t_bool",
																"typeString": "bool"
															},
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"operator": "&&",
															"type": "bool"
														},
														"children": [
															{
																"attributes": {
																	"argumentTypes": null,
																	"commonType": {
																		"typeIdentifier": "t_bool",
																		"typeString": "bool"
																	},
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"lValueRequested": false,
																	"operator": "&&",
																	"type": "bool"
																},
																"children": [
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"isConstant": false,
																			"isLValue": true,
																			"isPure": false,
																			"lValueRequested": false,
																			"type": "bool"
																		},
																		"children": [
																			{
																				"attributes": {
																					"argumentTypes": null,
																					"overloadedDeclarations": [
																						null
																					],
																					"referencedDeclaration": 1059,
																					"type": "mapping(address => bool)",
																					"value": "approvedForExperiences"
																				},
																				"id": 1194,
																				"name": "Identifier",
																				"src": "2976:22:2"
																			},
																			{
																				"attributes": {
																					"argumentTypes": null,
																					"isConstant": false,
																					"isLValue": false,
																					"isPure": false,
																					"lValueRequested": false,
																					"member_name": "sender",
																					"referencedDeclaration": null,
																					"type": "address"
																				},
																				"children": [
																					{
																						"attributes": {
																							"argumentTypes": null,
																							"overloadedDeclarations": [
																								null
																							],
																							"referencedDeclaration": 1974,
																							"type": "msg",
																							"value": "msg"
																						},
																						"id": 1195,
																						"name": "Identifier",
																						"src": "2999:3:2"
																					}
																				],
																				"id": 1196,
																				"name": "MemberAccess",
																				"src": "2999:10:2"
																			}
																		],
																		"id": 1197,
																		"name": "IndexAccess",
																		"src": "2976:34:2"
																	},
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"commonType": {
																				"typeIdentifier": "t_uint256",
																				"typeString": "uint256"
																			},
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": false,
																			"lValueRequested": false,
																			"operator": "!=",
																			"type": "bool"
																		},
																		"children": [
																			{
																				"attributes": {
																					"argumentTypes": null,
																					"overloadedDeclarations": [
																						null
																					],
																					"referencedDeclaration": 1051,
																					"type": "uint256",
																					"value": "amountOfTokensForPosting"
																				},
																				"id": 1198,
																				"name": "Identifier",
																				"src": "3014:24:2"
																			},
																			{
																				"attributes": {
																					"argumentTypes": null,
																					"hexvalue": "30",
																					"isConstant": false,
																					"isLValue": false,
																					"isPure": true,
																					"lValueRequested": false,
																					"subdenomination": null,
																					"token": "number",
																					"type": "int_const 0",
																					"value": "0"
																				},
																				"id": 1199,
																				"name": "Literal",
																				"src": "3042:1:2"
																			}
																		],
																		"id": 1200,
																		"name": "BinaryOperation",
																		"src": "3014:29:2"
																	}
																],
																"id": 1201,
																"name": "BinaryOperation",
																"src": "2976:67:2"
															},
															{
																"attributes": {
																	"argumentTypes": null,
																	"commonType": {
																		"typeIdentifier": "t_uint256",
																		"typeString": "uint256"
																	},
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"lValueRequested": false,
																	"operator": "!=",
																	"type": "bool"
																},
																"children": [
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"overloadedDeclarations": [
																				null
																			],
																			"referencedDeclaration": 1053,
																			"type": "uint256",
																			"value": "amountOfTokensForQuerying"
																		},
																		"id": 1202,
																		"name": "Identifier",
																		"src": "3047:25:2"
																	},
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"hexvalue": "30",
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": true,
																			"lValueRequested": false,
																			"subdenomination": null,
																			"token": "number",
																			"type": "int_const 0",
																			"value": "0"
																		},
																		"id": 1203,
																		"name": "Literal",
																		"src": "3076:1:2"
																	}
																],
																"id": 1204,
																"name": "BinaryOperation",
																"src": "3047:30:2"
															}
														],
														"id": 1205,
														"name": "BinaryOperation",
														"src": "2976:101:2"
													}
												],
												"id": 1206,
												"name": "FunctionCall",
												"src": "2968:110:2"
											}
										],
										"id": 1207,
										"name": "ExpressionStatement",
										"src": "2968:110:2"
									},
									{
										"attributes": {
											"assignments": [
												1209
											]
										},
										"children": [
											{
												"attributes": {
													"constant": false,
													"name": "experienceId",
													"scope": 1278,
													"stateVariable": false,
													"storageLocation": "default",
													"type": "uint256",
													"value": null,
													"visibility": "internal"
												},
												"children": [
													{
														"attributes": {
															"name": "uint256",
															"type": "uint256"
														},
														"id": 1208,
														"name": "ElementaryTypeName",
														"src": "3097:7:2"
													}
												],
												"id": 1209,
												"name": "VariableDeclaration",
												"src": "3097:20:2"
											},
											{
												"attributes": {
													"argumentTypes": null,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"operator": "++",
													"prefix": true,
													"type": "uint256"
												},
												"children": [
													{
														"attributes": {
															"argumentTypes": null,
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 1049,
															"type": "uint256",
															"value": "lastExperienceId"
														},
														"id": 1210,
														"name": "Identifier",
														"src": "3122:16:2"
													}
												],
												"id": 1211,
												"name": "UnaryOperation",
												"src": "3120:18:2"
											}
										],
										"id": 1212,
										"name": "VariableDeclarationStatement",
										"src": "3097:41:2"
									},
									{
										"children": [
											{
												"attributes": {
													"argumentTypes": null,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"operator": "=",
													"type": "uint256"
												},
												"children": [
													{
														"attributes": {
															"argumentTypes": null,
															"isConstant": false,
															"isLValue": true,
															"isPure": false,
															"lValueRequested": true,
															"member_name": "yearOfExperience",
															"referencedDeclaration": 1042,
															"type": "uint256"
														},
														"children": [
															{
																"attributes": {
																	"argumentTypes": null,
																	"isConstant": false,
																	"isLValue": true,
																	"isPure": false,
																	"lValueRequested": false,
																	"type": "struct ExperienceStore.experience storage ref"
																},
																"children": [
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"overloadedDeclarations": [
																				null
																			],
																			"referencedDeclaration": 1063,
																			"type": "mapping(uint256 => struct ExperienceStore.experience storage ref)",
																			"value": "Experience"
																		},
																		"id": 1213,
																		"name": "Identifier",
																		"src": "3215:10:2"
																	},
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"overloadedDeclarations": [
																				null
																			],
																			"referencedDeclaration": 1209,
																			"type": "uint256",
																			"value": "experienceId"
																		},
																		"id": 1214,
																		"name": "Identifier",
																		"src": "3226:12:2"
																	}
																],
																"id": 1215,
																"name": "IndexAccess",
																"src": "3215:24:2"
															}
														],
														"id": 1216,
														"name": "MemberAccess",
														"src": "3215:41:2"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 1188,
															"type": "uint256",
															"value": "_yearOfExperience"
														},
														"id": 1217,
														"name": "Identifier",
														"src": "3259:17:2"
													}
												],
												"id": 1218,
												"name": "Assignment",
												"src": "3215:61:2"
											}
										],
										"id": 1219,
										"name": "ExpressionStatement",
										"src": "3215:61:2"
									},
									{
										"children": [
											{
												"attributes": {
													"argumentTypes": null,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"operator": "=",
													"type": "address"
												},
												"children": [
													{
														"attributes": {
															"argumentTypes": null,
															"isConstant": false,
															"isLValue": true,
															"isPure": false,
															"lValueRequested": true,
															"member_name": "employee",
															"referencedDeclaration": 1040,
															"type": "address"
														},
														"children": [
															{
																"attributes": {
																	"argumentTypes": null,
																	"isConstant": false,
																	"isLValue": true,
																	"isPure": false,
																	"lValueRequested": false,
																	"type": "struct ExperienceStore.experience storage ref"
																},
																"children": [
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"overloadedDeclarations": [
																				null
																			],
																			"referencedDeclaration": 1063,
																			"type": "mapping(uint256 => struct ExperienceStore.experience storage ref)",
																			"value": "Experience"
																		},
																		"id": 1220,
																		"name": "Identifier",
																		"src": "3286:10:2"
																	},
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"overloadedDeclarations": [
																				null
																			],
																			"referencedDeclaration": 1209,
																			"type": "uint256",
																			"value": "experienceId"
																		},
																		"id": 1221,
																		"name": "Identifier",
																		"src": "3297:12:2"
																	}
																],
																"id": 1222,
																"name": "IndexAccess",
																"src": "3286:24:2"
															}
														],
														"id": 1223,
														"name": "MemberAccess",
														"src": "3286:33:2"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 1186,
															"type": "address",
															"value": "employeeAddr"
														},
														"id": 1224,
														"name": "Identifier",
														"src": "3322:12:2"
													}
												],
												"id": 1225,
												"name": "Assignment",
												"src": "3286:48:2"
											}
										],
										"id": 1226,
										"name": "ExpressionStatement",
										"src": "3286:48:2"
									},
									{
										"children": [
											{
												"attributes": {
													"argumentTypes": null,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"operator": "=",
													"type": "address"
												},
												"children": [
													{
														"attributes": {
															"argumentTypes": null,
															"isConstant": false,
															"isLValue": true,
															"isPure": false,
															"lValueRequested": true,
															"member_name": "employer",
															"referencedDeclaration": 1038,
															"type": "address"
														},
														"children": [
															{
																"attributes": {
																	"argumentTypes": null,
																	"isConstant": false,
																	"isLValue": true,
																	"isPure": false,
																	"lValueRequested": false,
																	"type": "struct ExperienceStore.experience storage ref"
																},
																"children": [
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"overloadedDeclarations": [
																				null
																			],
																			"referencedDeclaration": 1063,
																			"type": "mapping(uint256 => struct ExperienceStore.experience storage ref)",
																			"value": "Experience"
																		},
																		"id": 1227,
																		"name": "Identifier",
																		"src": "3344:10:2"
																	},
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"overloadedDeclarations": [
																				null
																			],
																			"referencedDeclaration": 1209,
																			"type": "uint256",
																			"value": "experienceId"
																		},
																		"id": 1228,
																		"name": "Identifier",
																		"src": "3355:12:2"
																	}
																],
																"id": 1229,
																"name": "IndexAccess",
																"src": "3344:24:2"
															}
														],
														"id": 1230,
														"name": "MemberAccess",
														"src": "3344:33:2"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"member_name": "sender",
															"referencedDeclaration": null,
															"type": "address"
														},
														"children": [
															{
																"attributes": {
																	"argumentTypes": null,
																	"overloadedDeclarations": [
																		null
																	],
																	"referencedDeclaration": 1974,
																	"type": "msg",
																	"value": "msg"
																},
																"id": 1231,
																"name": "Identifier",
																"src": "3380:3:2"
															}
														],
														"id": 1232,
														"name": "MemberAccess",
														"src": "3380:10:2"
													}
												],
												"id": 1233,
												"name": "Assignment",
												"src": "3344:46:2"
											}
										],
										"id": 1234,
										"name": "ExpressionStatement",
										"src": "3344:46:2"
									},
									{
										"children": [
											{
												"attributes": {
													"argumentTypes": null,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"operator": "=",
													"type": "bytes32"
												},
												"children": [
													{
														"attributes": {
															"argumentTypes": null,
															"isConstant": false,
															"isLValue": true,
															"isPure": false,
															"lValueRequested": true,
															"member_name": "experienceFor",
															"referencedDeclaration": 1044,
															"type": "bytes32"
														},
														"children": [
															{
																"attributes": {
																	"argumentTypes": null,
																	"isConstant": false,
																	"isLValue": true,
																	"isPure": false,
																	"lValueRequested": false,
																	"type": "struct ExperienceStore.experience storage ref"
																},
																"children": [
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"overloadedDeclarations": [
																				null
																			],
																			"referencedDeclaration": 1063,
																			"type": "mapping(uint256 => struct ExperienceStore.experience storage ref)",
																			"value": "Experience"
																		},
																		"id": 1235,
																		"name": "Identifier",
																		"src": "3400:10:2"
																	},
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"overloadedDeclarations": [
																				null
																			],
																			"referencedDeclaration": 1209,
																			"type": "uint256",
																			"value": "experienceId"
																		},
																		"id": 1236,
																		"name": "Identifier",
																		"src": "3411:12:2"
																	}
																],
																"id": 1237,
																"name": "IndexAccess",
																"src": "3400:24:2"
															}
														],
														"id": 1238,
														"name": "MemberAccess",
														"src": "3400:38:2"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 1190,
															"type": "bytes32",
															"value": "_experienceFor"
														},
														"id": 1239,
														"name": "Identifier",
														"src": "3441:14:2"
													}
												],
												"id": 1240,
												"name": "Assignment",
												"src": "3400:55:2"
											}
										],
										"id": 1241,
										"name": "ExpressionStatement",
										"src": "3400:55:2"
									},
									{
										"children": [
											{
												"attributes": {
													"argumentTypes": null,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"isStructConstructorCall": false,
													"lValueRequested": false,
													"names": [
														null
													],
													"type": "uint256",
													"type_conversion": false
												},
												"children": [
													{
														"attributes": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_address",
																	"typeString": "address"
																}
															],
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"member_name": "push",
															"referencedDeclaration": null,
															"type": "function (address) returns (uint256)"
														},
														"children": [
															{
																"attributes": {
																	"argumentTypes": null,
																	"isConstant": false,
																	"isLValue": true,
																	"isPure": false,
																	"lValueRequested": false,
																	"type": "address[] storage ref"
																},
																"children": [
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"isConstant": false,
																			"isLValue": true,
																			"isPure": false,
																			"lValueRequested": false,
																			"type": "mapping(uint256 => address[] storage ref)"
																		},
																		"children": [
																			{
																				"attributes": {
																					"argumentTypes": null,
																					"overloadedDeclarations": [
																						null
																					],
																					"referencedDeclaration": 1077,
																					"type": "mapping(bytes32 => mapping(uint256 => address[] storage ref))",
																					"value": "mappingArrayOfEmployer"
																				},
																				"id": 1242,
																				"name": "Identifier",
																				"src": "3530:22:2"
																			},
																			{
																				"attributes": {
																					"argumentTypes": null,
																					"overloadedDeclarations": [
																						null
																					],
																					"referencedDeclaration": 1190,
																					"type": "bytes32",
																					"value": "_experienceFor"
																				},
																				"id": 1243,
																				"name": "Identifier",
																				"src": "3553:14:2"
																			}
																		],
																		"id": 1245,
																		"name": "IndexAccess",
																		"src": "3530:38:2"
																	},
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"overloadedDeclarations": [
																				null
																			],
																			"referencedDeclaration": 1188,
																			"type": "uint256",
																			"value": "_yearOfExperience"
																		},
																		"id": 1244,
																		"name": "Identifier",
																		"src": "3569:17:2"
																	}
																],
																"id": 1246,
																"name": "IndexAccess",
																"src": "3530:57:2"
															}
														],
														"id": 1247,
														"name": "MemberAccess",
														"src": "3530:62:2"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"member_name": "sender",
															"referencedDeclaration": null,
															"type": "address"
														},
														"children": [
															{
																"attributes": {
																	"argumentTypes": null,
																	"overloadedDeclarations": [
																		null
																	],
																	"referencedDeclaration": 1974,
																	"type": "msg",
																	"value": "msg"
																},
																"id": 1248,
																"name": "Identifier",
																"src": "3593:3:2"
															}
														],
														"id": 1249,
														"name": "MemberAccess",
														"src": "3593:10:2"
													}
												],
												"id": 1250,
												"name": "FunctionCall",
												"src": "3530:74:2"
											}
										],
										"id": 1251,
										"name": "ExpressionStatement",
										"src": "3530:74:2"
									},
									{
										"children": [
											{
												"attributes": {
													"argumentTypes": null,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"isStructConstructorCall": false,
													"lValueRequested": false,
													"names": [
														null
													],
													"type": "uint256",
													"type_conversion": false
												},
												"children": [
													{
														"attributes": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_address",
																	"typeString": "address"
																}
															],
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"member_name": "push",
															"referencedDeclaration": null,
															"type": "function (address) returns (uint256)"
														},
														"children": [
															{
																"attributes": {
																	"argumentTypes": null,
																	"isConstant": false,
																	"isLValue": true,
																	"isPure": false,
																	"lValueRequested": false,
																	"type": "address[] storage ref"
																},
																"children": [
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"isConstant": false,
																			"isLValue": true,
																			"isPure": false,
																			"lValueRequested": false,
																			"type": "mapping(uint256 => address[] storage ref)"
																		},
																		"children": [
																			{
																				"attributes": {
																					"argumentTypes": null,
																					"overloadedDeclarations": [
																						null
																					],
																					"referencedDeclaration": 1070,
																					"type": "mapping(bytes32 => mapping(uint256 => address[] storage ref))",
																					"value": "mappingArrayOfEmployee"
																				},
																				"id": 1252,
																				"name": "Identifier",
																				"src": "3678:22:2"
																			},
																			{
																				"attributes": {
																					"argumentTypes": null,
																					"overloadedDeclarations": [
																						null
																					],
																					"referencedDeclaration": 1190,
																					"type": "bytes32",
																					"value": "_experienceFor"
																				},
																				"id": 1253,
																				"name": "Identifier",
																				"src": "3701:14:2"
																			}
																		],
																		"id": 1255,
																		"name": "IndexAccess",
																		"src": "3678:38:2"
																	},
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"overloadedDeclarations": [
																				null
																			],
																			"referencedDeclaration": 1188,
																			"type": "uint256",
																			"value": "_yearOfExperience"
																		},
																		"id": 1254,
																		"name": "Identifier",
																		"src": "3717:17:2"
																	}
																],
																"id": 1256,
																"name": "IndexAccess",
																"src": "3678:57:2"
															}
														],
														"id": 1257,
														"name": "MemberAccess",
														"src": "3678:62:2"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 1186,
															"type": "address",
															"value": "employeeAddr"
														},
														"id": 1258,
														"name": "Identifier",
														"src": "3741:12:2"
													}
												],
												"id": 1259,
												"name": "FunctionCall",
												"src": "3678:76:2"
											}
										],
										"id": 1260,
										"name": "ExpressionStatement",
										"src": "3678:76:2"
									},
									{
										"children": [
											{
												"attributes": {
													"argumentTypes": null,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"isStructConstructorCall": false,
													"lValueRequested": false,
													"names": [
														null
													],
													"type": "bool",
													"type_conversion": false
												},
												"children": [
													{
														"attributes": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_address",
																	"typeString": "address"
																},
																{
																	"typeIdentifier": "t_address",
																	"typeString": "address"
																},
																{
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																}
															],
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"member_name": "transferFrom",
															"referencedDeclaration": 442,
															"type": "function (address,address,uint256) external returns (bool)"
														},
														"children": [
															{
																"attributes": {
																	"argumentTypes": null,
																	"overloadedDeclarations": [
																		null
																	],
																	"referencedDeclaration": 1055,
																	"type": "contract EchoLinkToken",
																	"value": "objEchoLink"
																},
																"id": 1261,
																"name": "Identifier",
																"src": "3822:11:2"
															}
														],
														"id": 1263,
														"name": "MemberAccess",
														"src": "3822:24:2"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"member_name": "sender",
															"referencedDeclaration": null,
															"type": "address"
														},
														"children": [
															{
																"attributes": {
																	"argumentTypes": null,
																	"overloadedDeclarations": [
																		null
																	],
																	"referencedDeclaration": 1974,
																	"type": "msg",
																	"value": "msg"
																},
																"id": 1264,
																"name": "Identifier",
																"src": "3847:3:2"
															}
														],
														"id": 1265,
														"name": "MemberAccess",
														"src": "3847:10:2"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 1047,
															"type": "address",
															"value": "echoLinkFoundation"
														},
														"id": 1266,
														"name": "Identifier",
														"src": "3859:18:2"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 1051,
															"type": "uint256",
															"value": "amountOfTokensForPosting"
														},
														"id": 1267,
														"name": "Identifier",
														"src": "3879:24:2"
													}
												],
												"id": 1268,
												"name": "FunctionCall",
												"src": "3822:82:2"
											}
										],
										"id": 1269,
										"name": "ExpressionStatement",
										"src": "3822:82:2"
									},
									{
										"children": [
											{
												"attributes": {
													"argumentTypes": null,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"isStructConstructorCall": false,
													"lValueRequested": false,
													"names": [
														null
													],
													"type": "tuple()",
													"type_conversion": false
												},
												"children": [
													{
														"attributes": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_address",
																	"typeString": "address"
																},
																{
																	"typeIdentifier": "t_address",
																	"typeString": "address"
																},
																{
																	"typeIdentifier": "t_uint256",
																	"typeString": "uint256"
																}
															],
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 1095,
															"type": "function (address,address,uint256)",
															"value": "ExperienceAdded"
														},
														"id": 1270,
														"name": "Identifier",
														"src": "3914:15:2"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"member_name": "sender",
															"referencedDeclaration": null,
															"type": "address"
														},
														"children": [
															{
																"attributes": {
																	"argumentTypes": null,
																	"overloadedDeclarations": [
																		null
																	],
																	"referencedDeclaration": 1974,
																	"type": "msg",
																	"value": "msg"
																},
																"id": 1271,
																"name": "Identifier",
																"src": "3930:3:2"
															}
														],
														"id": 1272,
														"name": "MemberAccess",
														"src": "3930:10:2"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 1186,
															"type": "address",
															"value": "employeeAddr"
														},
														"id": 1273,
														"name": "Identifier",
														"src": "3942:12:2"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 1188,
															"type": "uint256",
															"value": "_yearOfExperience"
														},
														"id": 1274,
														"name": "Identifier",
														"src": "3956:17:2"
													}
												],
												"id": 1275,
												"name": "FunctionCall",
												"src": "3914:60:2"
											}
										],
										"id": 1276,
										"name": "ExpressionStatement",
										"src": "3914:60:2"
									}
								],
								"id": 1277,
								"name": "Block",
								"src": "2957:1024:2"
							}
						],
						"id": 1278,
						"name": "FunctionDefinition",
						"src": "2827:1154:2"
					},
					{
						"attributes": {
							"constant": false,
							"implemented": true,
							"isConstructor": false,
							"modifiers": [
								null
							],
							"name": "queryExperiences",
							"payable": false,
							"scope": 1472,
							"stateMutability": "nonpayable",
							"superFunction": null,
							"visibility": "public"
						},
						"children": [
							{
								"children": [
									{
										"attributes": {
											"constant": false,
											"name": "experienceDetails",
											"scope": 1416,
											"stateVariable": false,
											"storageLocation": "default",
											"type": "bytes32",
											"value": null,
											"visibility": "internal"
										},
										"children": [
											{
												"attributes": {
													"name": "bytes32",
													"type": "bytes32"
												},
												"id": 1279,
												"name": "ElementaryTypeName",
												"src": "4047:7:2"
											}
										],
										"id": 1280,
										"name": "VariableDeclaration",
										"src": "4047:25:2"
									},
									{
										"attributes": {
											"constant": false,
											"name": "experienceYear",
											"scope": 1416,
											"stateVariable": false,
											"storageLocation": "default",
											"type": "uint256",
											"value": null,
											"visibility": "internal"
										},
										"children": [
											{
												"attributes": {
													"name": "uint256",
													"type": "uint256"
												},
												"id": 1281,
												"name": "ElementaryTypeName",
												"src": "4074:7:2"
											}
										],
										"id": 1282,
										"name": "VariableDeclaration",
										"src": "4074:22:2"
									}
								],
								"id": 1283,
								"name": "ParameterList",
								"src": "4046:51:2"
							},
							{
								"attributes": {
									"parameters": [
										null
									]
								},
								"children": [],
								"id": 1284,
								"name": "ParameterList",
								"src": "4104:0:2"
							},
							{
								"children": [
									{
										"children": [
											{
												"attributes": {
													"argumentTypes": null,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"isStructConstructorCall": false,
													"lValueRequested": false,
													"names": [
														null
													],
													"type": "tuple()",
													"type_conversion": false
												},
												"children": [
													{
														"attributes": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_bool",
																	"typeString": "bool"
																}
															],
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 1977,
															"type": "function (bool) pure",
															"value": "require"
														},
														"id": 1285,
														"name": "Identifier",
														"src": "4114:7:2"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"commonType": {
																"typeIdentifier": "t_bool",
																"typeString": "bool"
															},
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"operator": "&&",
															"type": "bool"
														},
														"children": [
															{
																"attributes": {
																	"argumentTypes": null,
																	"commonType": {
																		"typeIdentifier": "t_uint256",
																		"typeString": "uint256"
																	},
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"lValueRequested": false,
																	"operator": "!=",
																	"type": "bool"
																},
																"children": [
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"overloadedDeclarations": [
																				null
																			],
																			"referencedDeclaration": 1051,
																			"type": "uint256",
																			"value": "amountOfTokensForPosting"
																		},
																		"id": 1286,
																		"name": "Identifier",
																		"src": "4122:24:2"
																	},
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"hexvalue": "30",
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": true,
																			"lValueRequested": false,
																			"subdenomination": null,
																			"token": "number",
																			"type": "int_const 0",
																			"value": "0"
																		},
																		"id": 1287,
																		"name": "Literal",
																		"src": "4150:1:2"
																	}
																],
																"id": 1288,
																"name": "BinaryOperation",
																"src": "4122:29:2"
															},
															{
																"attributes": {
																	"argumentTypes": null,
																	"commonType": {
																		"typeIdentifier": "t_uint256",
																		"typeString": "uint256"
																	},
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"lValueRequested": false,
																	"operator": "!=",
																	"type": "bool"
																},
																"children": [
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"overloadedDeclarations": [
																				null
																			],
																			"referencedDeclaration": 1053,
																			"type": "uint256",
																			"value": "amountOfTokensForQuerying"
																		},
																		"id": 1289,
																		"name": "Identifier",
																		"src": "4155:25:2"
																	},
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"hexvalue": "30",
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": true,
																			"lValueRequested": false,
																			"subdenomination": null,
																			"token": "number",
																			"type": "int_const 0",
																			"value": "0"
																		},
																		"id": 1290,
																		"name": "Literal",
																		"src": "4184:1:2"
																	}
																],
																"id": 1291,
																"name": "BinaryOperation",
																"src": "4155:30:2"
															}
														],
														"id": 1292,
														"name": "BinaryOperation",
														"src": "4122:63:2"
													}
												],
												"id": 1293,
												"name": "FunctionCall",
												"src": "4114:72:2"
											}
										],
										"id": 1294,
										"name": "ExpressionStatement",
										"src": "4114:72:2"
									},
									{
										"attributes": {
											"assignments": [
												null
											],
											"initialValue": null
										},
										"children": [
											{
												"attributes": {
													"constant": false,
													"name": "arrayEmployer",
													"scope": 1416,
													"stateVariable": false,
													"storageLocation": "memory",
													"type": "address[] memory",
													"value": null,
													"visibility": "internal"
												},
												"children": [
													{
														"attributes": {
															"length": null,
															"type": "address[] storage pointer"
														},
														"children": [
															{
																"attributes": {
																	"name": "address",
																	"type": "address"
																},
																"id": 1296,
																"name": "ElementaryTypeName",
																"src": "4223:7:2"
															}
														],
														"id": 1297,
														"name": "ArrayTypeName",
														"src": "4223:10:2"
													}
												],
												"id": 1298,
												"name": "VariableDeclaration",
												"src": "4223:31:2"
											}
										],
										"id": 1299,
										"name": "VariableDeclarationStatement",
										"src": "4223:31:2"
									},
									{
										"attributes": {
											"assignments": [
												null
											],
											"initialValue": null
										},
										"children": [
											{
												"attributes": {
													"constant": false,
													"name": "arrayEmployee",
													"scope": 1416,
													"stateVariable": false,
													"storageLocation": "memory",
													"type": "address[] memory",
													"value": null,
													"visibility": "internal"
												},
												"children": [
													{
														"attributes": {
															"length": null,
															"type": "address[] storage pointer"
														},
														"children": [
															{
																"attributes": {
																	"name": "address",
																	"type": "address"
																},
																"id": 1301,
																"name": "ElementaryTypeName",
																"src": "4264:7:2"
															}
														],
														"id": 1302,
														"name": "ArrayTypeName",
														"src": "4264:10:2"
													}
												],
												"id": 1303,
												"name": "VariableDeclaration",
												"src": "4264:31:2"
											}
										],
										"id": 1304,
										"name": "VariableDeclarationStatement",
										"src": "4264:31:2"
									},
									{
										"attributes": {
											"assignments": [
												null
											],
											"initialValue": null
										},
										"children": [
											{
												"attributes": {
													"constant": false,
													"name": "length",
													"scope": 1416,
													"stateVariable": false,
													"storageLocation": "default",
													"type": "uint256",
													"value": null,
													"visibility": "internal"
												},
												"children": [
													{
														"attributes": {
															"name": "uint256",
															"type": "uint256"
														},
														"id": 1305,
														"name": "ElementaryTypeName",
														"src": "4305:7:2"
													}
												],
												"id": 1306,
												"name": "VariableDeclaration",
												"src": "4305:14:2"
											}
										],
										"id": 1307,
										"name": "VariableDeclarationStatement",
										"src": "4305:14:2"
									},
									{
										"attributes": {
											"assignments": [
												1309
											]
										},
										"children": [
											{
												"attributes": {
													"constant": false,
													"name": "from",
													"scope": 1416,
													"stateVariable": false,
													"storageLocation": "default",
													"type": "address",
													"value": null,
													"visibility": "internal"
												},
												"children": [
													{
														"attributes": {
															"name": "address",
															"type": "address"
														},
														"id": 1308,
														"name": "ElementaryTypeName",
														"src": "4329:7:2"
													}
												],
												"id": 1309,
												"name": "VariableDeclaration",
												"src": "4329:12:2"
											},
											{
												"attributes": {
													"argumentTypes": null,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"member_name": "sender",
													"referencedDeclaration": null,
													"type": "address"
												},
												"children": [
													{
														"attributes": {
															"argumentTypes": null,
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 1974,
															"type": "msg",
															"value": "msg"
														},
														"id": 1310,
														"name": "Identifier",
														"src": "4344:3:2"
													}
												],
												"id": 1311,
												"name": "MemberAccess",
												"src": "4344:10:2"
											}
										],
										"id": 1312,
										"name": "VariableDeclarationStatement",
										"src": "4329:25:2"
									},
									{
										"children": [
											{
												"attributes": {
													"argumentTypes": null,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"operator": "=",
													"type": "address[] memory"
												},
												"children": [
													{
														"attributes": {
															"argumentTypes": null,
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 1298,
															"type": "address[] memory",
															"value": "arrayEmployer"
														},
														"id": 1313,
														"name": "Identifier",
														"src": "4364:13:2"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"isConstant": false,
															"isLValue": true,
															"isPure": false,
															"lValueRequested": false,
															"type": "address[] storage ref"
														},
														"children": [
															{
																"attributes": {
																	"argumentTypes": null,
																	"isConstant": false,
																	"isLValue": true,
																	"isPure": false,
																	"lValueRequested": false,
																	"type": "mapping(uint256 => address[] storage ref)"
																},
																"children": [
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"overloadedDeclarations": [
																				null
																			],
																			"referencedDeclaration": 1077,
																			"type": "mapping(bytes32 => mapping(uint256 => address[] storage ref))",
																			"value": "mappingArrayOfEmployer"
																		},
																		"id": 1314,
																		"name": "Identifier",
																		"src": "4380:22:2"
																	},
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"overloadedDeclarations": [
																				null
																			],
																			"referencedDeclaration": 1280,
																			"type": "bytes32",
																			"value": "experienceDetails"
																		},
																		"id": 1315,
																		"name": "Identifier",
																		"src": "4403:17:2"
																	}
																],
																"id": 1316,
																"name": "IndexAccess",
																"src": "4380:41:2"
															},
															{
																"attributes": {
																	"argumentTypes": null,
																	"overloadedDeclarations": [
																		null
																	],
																	"referencedDeclaration": 1282,
																	"type": "uint256",
																	"value": "experienceYear"
																},
																"id": 1317,
																"name": "Identifier",
																"src": "4422:14:2"
															}
														],
														"id": 1318,
														"name": "IndexAccess",
														"src": "4380:57:2"
													}
												],
												"id": 1319,
												"name": "Assignment",
												"src": "4364:73:2"
											}
										],
										"id": 1320,
										"name": "ExpressionStatement",
										"src": "4364:73:2"
									},
									{
										"children": [
											{
												"attributes": {
													"argumentTypes": null,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"operator": "=",
													"type": "address[] memory"
												},
												"children": [
													{
														"attributes": {
															"argumentTypes": null,
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 1303,
															"type": "address[] memory",
															"value": "arrayEmployee"
														},
														"id": 1321,
														"name": "Identifier",
														"src": "4447:13:2"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"isConstant": false,
															"isLValue": true,
															"isPure": false,
															"lValueRequested": false,
															"type": "address[] storage ref"
														},
														"children": [
															{
																"attributes": {
																	"argumentTypes": null,
																	"isConstant": false,
																	"isLValue": true,
																	"isPure": false,
																	"lValueRequested": false,
																	"type": "mapping(uint256 => address[] storage ref)"
																},
																"children": [
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"overloadedDeclarations": [
																				null
																			],
																			"referencedDeclaration": 1070,
																			"type": "mapping(bytes32 => mapping(uint256 => address[] storage ref))",
																			"value": "mappingArrayOfEmployee"
																		},
																		"id": 1322,
																		"name": "Identifier",
																		"src": "4463:22:2"
																	},
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"overloadedDeclarations": [
																				null
																			],
																			"referencedDeclaration": 1280,
																			"type": "bytes32",
																			"value": "experienceDetails"
																		},
																		"id": 1323,
																		"name": "Identifier",
																		"src": "4486:17:2"
																	}
																],
																"id": 1324,
																"name": "IndexAccess",
																"src": "4463:41:2"
															},
															{
																"attributes": {
																	"argumentTypes": null,
																	"overloadedDeclarations": [
																		null
																	],
																	"referencedDeclaration": 1282,
																	"type": "uint256",
																	"value": "experienceYear"
																},
																"id": 1325,
																"name": "Identifier",
																"src": "4505:14:2"
															}
														],
														"id": 1326,
														"name": "IndexAccess",
														"src": "4463:57:2"
													}
												],
												"id": 1327,
												"name": "Assignment",
												"src": "4447:73:2"
											}
										],
										"id": 1328,
										"name": "ExpressionStatement",
										"src": "4447:73:2"
									},
									{
										"children": [
											{
												"attributes": {
													"argumentTypes": null,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"operator": "=",
													"type": "uint256"
												},
												"children": [
													{
														"attributes": {
															"argumentTypes": null,
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 1306,
															"type": "uint256",
															"value": "length"
														},
														"id": 1329,
														"name": "Identifier",
														"src": "4531:6:2"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"isConstant": false,
															"isLValue": false,
															"isPure": false,
															"lValueRequested": false,
															"member_name": "length",
															"referencedDeclaration": null,
															"type": "uint256"
														},
														"children": [
															{
																"attributes": {
																	"argumentTypes": null,
																	"overloadedDeclarations": [
																		null
																	],
																	"referencedDeclaration": 1303,
																	"type": "address[] memory",
																	"value": "arrayEmployee"
																},
																"id": 1330,
																"name": "Identifier",
																"src": "4540:13:2"
															}
														],
														"id": 1331,
														"name": "MemberAccess",
														"src": "4540:20:2"
													}
												],
												"id": 1332,
												"name": "Assignment",
												"src": "4531:29:2"
											}
										],
										"id": 1333,
										"name": "ExpressionStatement",
										"src": "4531:29:2"
									},
									{
										"children": [
											{
												"attributes": {
													"argumentTypes": null,
													"commonType": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													},
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"operator": "==",
													"type": "bool"
												},
												"children": [
													{
														"attributes": {
															"argumentTypes": null,
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 1306,
															"type": "uint256",
															"value": "length"
														},
														"id": 1334,
														"name": "Identifier",
														"src": "4648:6:2"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"hexvalue": "30",
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"subdenomination": null,
															"token": "number",
															"type": "int_const 0",
															"value": "0"
														},
														"id": 1335,
														"name": "Literal",
														"src": "4658:1:2"
													}
												],
												"id": 1336,
												"name": "BinaryOperation",
												"src": "4648:11:2"
											},
											{
												"children": [
													{
														"children": [
															{
																"attributes": {
																	"argumentTypes": null,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"isStructConstructorCall": false,
																	"lValueRequested": false,
																	"names": [
																		null
																	],
																	"type": "bool",
																	"type_conversion": false
																},
																"children": [
																	{
																		"attributes": {
																			"argumentTypes": [
																				{
																					"typeIdentifier": "t_address",
																					"typeString": "address"
																				},
																				{
																					"typeIdentifier": "t_address",
																					"typeString": "address"
																				},
																				{
																					"typeIdentifier": "t_uint256",
																					"typeString": "uint256"
																				}
																			],
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": false,
																			"lValueRequested": false,
																			"member_name": "transferFrom",
																			"referencedDeclaration": 442,
																			"type": "function (address,address,uint256) external returns (bool)"
																		},
																		"children": [
																			{
																				"attributes": {
																					"argumentTypes": null,
																					"overloadedDeclarations": [
																						null
																					],
																					"referencedDeclaration": 1055,
																					"type": "contract EchoLinkToken",
																					"value": "objEchoLink"
																				},
																				"id": 1337,
																				"name": "Identifier",
																				"src": "4674:11:2"
																			}
																		],
																		"id": 1339,
																		"name": "MemberAccess",
																		"src": "4674:24:2"
																	},
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"overloadedDeclarations": [
																				null
																			],
																			"referencedDeclaration": 1309,
																			"type": "address",
																			"value": "from"
																		},
																		"id": 1340,
																		"name": "Identifier",
																		"src": "4699:4:2"
																	},
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"overloadedDeclarations": [
																				null
																			],
																			"referencedDeclaration": 1047,
																			"type": "address",
																			"value": "echoLinkFoundation"
																		},
																		"id": 1341,
																		"name": "Identifier",
																		"src": "4705:18:2"
																	},
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"overloadedDeclarations": [
																				null
																			],
																			"referencedDeclaration": 1053,
																			"type": "uint256",
																			"value": "amountOfTokensForQuerying"
																		},
																		"id": 1342,
																		"name": "Identifier",
																		"src": "4725:25:2"
																	}
																],
																"id": 1343,
																"name": "FunctionCall",
																"src": "4674:77:2"
															}
														],
														"id": 1344,
														"name": "ExpressionStatement",
														"src": "4674:77:2"
													}
												],
												"id": 1345,
												"name": "Block",
												"src": "4660:102:2"
											},
											{
												"children": [
													{
														"attributes": {
															"assignments": [
																1347
															]
														},
														"children": [
															{
																"attributes": {
																	"constant": false,
																	"name": "amountTokenPay",
																	"scope": 1416,
																	"stateVariable": false,
																	"storageLocation": "default",
																	"type": "uint256",
																	"value": null,
																	"visibility": "internal"
																},
																"children": [
																	{
																		"attributes": {
																			"name": "uint256",
																			"type": "uint256"
																		},
																		"id": 1346,
																		"name": "ElementaryTypeName",
																		"src": "4866:7:2"
																	}
																],
																"id": 1347,
																"name": "VariableDeclaration",
																"src": "4866:22:2"
															},
															{
																"attributes": {
																	"argumentTypes": null,
																	"commonType": {
																		"typeIdentifier": "t_uint256",
																		"typeString": "uint256"
																	},
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"lValueRequested": false,
																	"operator": "/",
																	"type": "uint256"
																},
																"children": [
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"overloadedDeclarations": [
																				null
																			],
																			"referencedDeclaration": 1053,
																			"type": "uint256",
																			"value": "amountOfTokensForQuerying"
																		},
																		"id": 1348,
																		"name": "Identifier",
																		"src": "4891:25:2"
																	},
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"hexvalue": "33",
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": true,
																			"lValueRequested": false,
																			"subdenomination": null,
																			"token": "number",
																			"type": "int_const 3",
																			"value": "3"
																		},
																		"id": 1349,
																		"name": "Literal",
																		"src": "4919:1:2"
																	}
																],
																"id": 1350,
																"name": "BinaryOperation",
																"src": "4891:29:2"
															}
														],
														"id": 1351,
														"name": "VariableDeclarationStatement",
														"src": "4866:54:2"
													},
													{
														"children": [
															{
																"attributes": {
																	"argumentTypes": null,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"lValueRequested": false,
																	"operator": "=",
																	"type": "bool"
																},
																"children": [
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"isConstant": false,
																			"isLValue": true,
																			"isPure": false,
																			"lValueRequested": true,
																			"type": "bool"
																		},
																		"children": [
																			{
																				"attributes": {
																					"argumentTypes": null,
																					"overloadedDeclarations": [
																						null
																					],
																					"referencedDeclaration": 1081,
																					"type": "mapping(address => bool)",
																					"value": "experienceSet"
																				},
																				"id": 1352,
																				"name": "Identifier",
																				"src": "4934:13:2"
																			},
																			{
																				"attributes": {
																					"argumentTypes": null,
																					"isConstant": false,
																					"isLValue": false,
																					"isPure": false,
																					"lValueRequested": false,
																					"member_name": "sender",
																					"referencedDeclaration": null,
																					"type": "address"
																				},
																				"children": [
																					{
																						"attributes": {
																							"argumentTypes": null,
																							"overloadedDeclarations": [
																								null
																							],
																							"referencedDeclaration": 1974,
																							"type": "msg",
																							"value": "msg"
																						},
																						"id": 1353,
																						"name": "Identifier",
																						"src": "4948:3:2"
																					}
																				],
																				"id": 1354,
																				"name": "MemberAccess",
																				"src": "4948:10:2"
																			}
																		],
																		"id": 1355,
																		"name": "IndexAccess",
																		"src": "4934:25:2"
																	},
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"hexvalue": "74727565",
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": true,
																			"lValueRequested": false,
																			"subdenomination": null,
																			"token": "bool",
																			"type": "bool",
																			"value": "true"
																		},
																		"id": 1356,
																		"name": "Literal",
																		"src": "4962:4:2"
																	}
																],
																"id": 1357,
																"name": "Assignment",
																"src": "4934:32:2"
															}
														],
														"id": 1358,
														"name": "ExpressionStatement",
														"src": "4934:32:2"
													},
													{
														"children": [
															{
																"attributes": {
																	"argumentTypes": null,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"isStructConstructorCall": false,
																	"lValueRequested": false,
																	"names": [
																		null
																	],
																	"type": "bool",
																	"type_conversion": false
																},
																"children": [
																	{
																		"attributes": {
																			"argumentTypes": [
																				{
																					"typeIdentifier": "t_address",
																					"typeString": "address"
																				},
																				{
																					"typeIdentifier": "t_address",
																					"typeString": "address"
																				},
																				{
																					"typeIdentifier": "t_uint256",
																					"typeString": "uint256"
																				}
																			],
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": false,
																			"lValueRequested": false,
																			"member_name": "transferFrom",
																			"referencedDeclaration": 442,
																			"type": "function (address,address,uint256) external returns (bool)"
																		},
																		"children": [
																			{
																				"attributes": {
																					"argumentTypes": null,
																					"overloadedDeclarations": [
																						null
																					],
																					"referencedDeclaration": 1055,
																					"type": "contract EchoLinkToken",
																					"value": "objEchoLink"
																				},
																				"id": 1359,
																				"name": "Identifier",
																				"src": "4980:11:2"
																			}
																		],
																		"id": 1361,
																		"name": "MemberAccess",
																		"src": "4980:24:2"
																	},
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"overloadedDeclarations": [
																				null
																			],
																			"referencedDeclaration": 1309,
																			"type": "address",
																			"value": "from"
																		},
																		"id": 1362,
																		"name": "Identifier",
																		"src": "5005:4:2"
																	},
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"overloadedDeclarations": [
																				null
																			],
																			"referencedDeclaration": 1047,
																			"type": "address",
																			"value": "echoLinkFoundation"
																		},
																		"id": 1363,
																		"name": "Identifier",
																		"src": "5011:18:2"
																	},
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"overloadedDeclarations": [
																				null
																			],
																			"referencedDeclaration": 1347,
																			"type": "uint256",
																			"value": "amountTokenPay"
																		},
																		"id": 1364,
																		"name": "Identifier",
																		"src": "5031:14:2"
																	}
																],
																"id": 1365,
																"name": "FunctionCall",
																"src": "4980:66:2"
															}
														],
														"id": 1366,
														"name": "ExpressionStatement",
														"src": "4980:66:2"
													},
													{
														"attributes": {
															"assignments": [
																1368
															]
														},
														"children": [
															{
																"attributes": {
																	"constant": false,
																	"name": "equalTokenIssuer",
																	"scope": 1416,
																	"stateVariable": false,
																	"storageLocation": "default",
																	"type": "uint256",
																	"value": null,
																	"visibility": "internal"
																},
																"children": [
																	{
																		"attributes": {
																			"name": "uint256",
																			"type": "uint256"
																		},
																		"id": 1367,
																		"name": "ElementaryTypeName",
																		"src": "5124:7:2"
																	}
																],
																"id": 1368,
																"name": "VariableDeclaration",
																"src": "5124:24:2"
															},
															{
																"attributes": {
																	"argumentTypes": null,
																	"commonType": {
																		"typeIdentifier": "t_uint256",
																		"typeString": "uint256"
																	},
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"lValueRequested": false,
																	"operator": "/",
																	"type": "uint256"
																},
																"children": [
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"overloadedDeclarations": [
																				null
																			],
																			"referencedDeclaration": 1347,
																			"type": "uint256",
																			"value": "amountTokenPay"
																		},
																		"id": 1369,
																		"name": "Identifier",
																		"src": "5151:14:2"
																	},
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"isConstant": false,
																			"isInlineArray": false,
																			"isLValue": false,
																			"isPure": false,
																			"lValueRequested": false,
																			"type": "uint256"
																		},
																		"children": [
																			{
																				"attributes": {
																					"argumentTypes": null,
																					"overloadedDeclarations": [
																						null
																					],
																					"referencedDeclaration": 1306,
																					"type": "uint256",
																					"value": "length"
																				},
																				"id": 1370,
																				"name": "Identifier",
																				"src": "5167:6:2"
																			}
																		],
																		"id": 1371,
																		"name": "TupleExpression",
																		"src": "5166:8:2"
																	}
																],
																"id": 1372,
																"name": "BinaryOperation",
																"src": "5151:23:2"
															}
														],
														"id": 1373,
														"name": "VariableDeclarationStatement",
														"src": "5124:50:2"
													},
													{
														"attributes": {
															"assignments": [
																1375
															]
														},
														"children": [
															{
																"attributes": {
																	"constant": false,
																	"name": "equalTokenRecepient",
																	"scope": 1416,
																	"stateVariable": false,
																	"storageLocation": "default",
																	"type": "uint256",
																	"value": null,
																	"visibility": "internal"
																},
																"children": [
																	{
																		"attributes": {
																			"name": "uint256",
																			"type": "uint256"
																		},
																		"id": 1374,
																		"name": "ElementaryTypeName",
																		"src": "5255:7:2"
																	}
																],
																"id": 1375,
																"name": "VariableDeclaration",
																"src": "5255:27:2"
															},
															{
																"attributes": {
																	"argumentTypes": null,
																	"commonType": {
																		"typeIdentifier": "t_uint256",
																		"typeString": "uint256"
																	},
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"lValueRequested": false,
																	"operator": "/",
																	"type": "uint256"
																},
																"children": [
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"overloadedDeclarations": [
																				null
																			],
																			"referencedDeclaration": 1347,
																			"type": "uint256",
																			"value": "amountTokenPay"
																		},
																		"id": 1376,
																		"name": "Identifier",
																		"src": "5285:14:2"
																	},
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"isConstant": false,
																			"isInlineArray": false,
																			"isLValue": false,
																			"isPure": false,
																			"lValueRequested": false,
																			"type": "uint256"
																		},
																		"children": [
																			{
																				"attributes": {
																					"argumentTypes": null,
																					"overloadedDeclarations": [
																						null
																					],
																					"referencedDeclaration": 1306,
																					"type": "uint256",
																					"value": "length"
																				},
																				"id": 1377,
																				"name": "Identifier",
																				"src": "5301:6:2"
																			}
																		],
																		"id": 1378,
																		"name": "TupleExpression",
																		"src": "5300:8:2"
																	}
																],
																"id": 1379,
																"name": "BinaryOperation",
																"src": "5285:23:2"
															}
														],
														"id": 1380,
														"name": "VariableDeclarationStatement",
														"src": "5255:53:2"
													},
													{
														"children": [
															{
																"attributes": {
																	"assignments": [
																		1382
																	]
																},
																"children": [
																	{
																		"attributes": {
																			"constant": false,
																			"name": "i",
																			"scope": 1416,
																			"stateVariable": false,
																			"storageLocation": "default",
																			"type": "uint256",
																			"value": null,
																			"visibility": "internal"
																		},
																		"children": [
																			{
																				"attributes": {
																					"name": "uint256",
																					"type": "uint256"
																				},
																				"id": 1381,
																				"name": "ElementaryTypeName",
																				"src": "5370:7:2"
																			}
																		],
																		"id": 1382,
																		"name": "VariableDeclaration",
																		"src": "5370:9:2"
																	},
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"hexvalue": "30",
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": true,
																			"lValueRequested": false,
																			"subdenomination": null,
																			"token": "number",
																			"type": "int_const 0",
																			"value": "0"
																		},
																		"id": 1383,
																		"name": "Literal",
																		"src": "5380:1:2"
																	}
																],
																"id": 1384,
																"name": "VariableDeclarationStatement",
																"src": "5370:11:2"
															},
															{
																"attributes": {
																	"argumentTypes": null,
																	"commonType": {
																		"typeIdentifier": "t_uint256",
																		"typeString": "uint256"
																	},
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"lValueRequested": false,
																	"operator": "<",
																	"type": "bool"
																},
																"children": [
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"overloadedDeclarations": [
																				null
																			],
																			"referencedDeclaration": 1382,
																			"type": "uint256",
																			"value": "i"
																		},
																		"id": 1385,
																		"name": "Identifier",
																		"src": "5383:1:2"
																	},
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"overloadedDeclarations": [
																				null
																			],
																			"referencedDeclaration": 1306,
																			"type": "uint256",
																			"value": "length"
																		},
																		"id": 1386,
																		"name": "Identifier",
																		"src": "5387:6:2"
																	}
																],
																"id": 1387,
																"name": "BinaryOperation",
																"src": "5383:10:2"
															},
															{
																"children": [
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"isConstant": false,
																			"isLValue": false,
																			"isPure": false,
																			"lValueRequested": false,
																			"operator": "++",
																			"prefix": false,
																			"type": "uint256"
																		},
																		"children": [
																			{
																				"attributes": {
																					"argumentTypes": null,
																					"overloadedDeclarations": [
																						null
																					],
																					"referencedDeclaration": 1382,
																					"type": "uint256",
																					"value": "i"
																				},
																				"id": 1388,
																				"name": "Identifier",
																				"src": "5395:1:2"
																			}
																		],
																		"id": 1389,
																		"name": "UnaryOperation",
																		"src": "5395:3:2"
																	}
																],
																"id": 1390,
																"name": "ExpressionStatement",
																"src": "5395:3:2"
															},
															{
																"children": [
																	{
																		"children": [
																			{
																				"attributes": {
																					"argumentTypes": null,
																					"isConstant": false,
																					"isLValue": false,
																					"isPure": false,
																					"isStructConstructorCall": false,
																					"lValueRequested": false,
																					"names": [
																						null
																					],
																					"type": "bool",
																					"type_conversion": false
																				},
																				"children": [
																					{
																						"attributes": {
																							"argumentTypes": [
																								{
																									"typeIdentifier": "t_address",
																									"typeString": "address"
																								},
																								{
																									"typeIdentifier": "t_address",
																									"typeString": "address"
																								},
																								{
																									"typeIdentifier": "t_uint256",
																									"typeString": "uint256"
																								}
																							],
																							"isConstant": false,
																							"isLValue": false,
																							"isPure": false,
																							"lValueRequested": false,
																							"member_name": "transferFrom",
																							"referencedDeclaration": 442,
																							"type": "function (address,address,uint256) external returns (bool)"
																						},
																						"children": [
																							{
																								"attributes": {
																									"argumentTypes": null,
																									"overloadedDeclarations": [
																										null
																									],
																									"referencedDeclaration": 1055,
																									"type": "contract EchoLinkToken",
																									"value": "objEchoLink"
																								},
																								"id": 1391,
																								"name": "Identifier",
																								"src": "5417:11:2"
																							}
																						],
																						"id": 1393,
																						"name": "MemberAccess",
																						"src": "5417:24:2"
																					},
																					{
																						"attributes": {
																							"argumentTypes": null,
																							"overloadedDeclarations": [
																								null
																							],
																							"referencedDeclaration": 1309,
																							"type": "address",
																							"value": "from"
																						},
																						"id": 1394,
																						"name": "Identifier",
																						"src": "5442:4:2"
																					},
																					{
																						"attributes": {
																							"argumentTypes": null,
																							"isConstant": false,
																							"isLValue": true,
																							"isPure": false,
																							"lValueRequested": false,
																							"type": "address"
																						},
																						"children": [
																							{
																								"attributes": {
																									"argumentTypes": null,
																									"overloadedDeclarations": [
																										null
																									],
																									"referencedDeclaration": 1298,
																									"type": "address[] memory",
																									"value": "arrayEmployer"
																								},
																								"id": 1395,
																								"name": "Identifier",
																								"src": "5448:13:2"
																							},
																							{
																								"attributes": {
																									"argumentTypes": null,
																									"overloadedDeclarations": [
																										null
																									],
																									"referencedDeclaration": 1382,
																									"type": "uint256",
																									"value": "i"
																								},
																								"id": 1396,
																								"name": "Identifier",
																								"src": "5462:1:2"
																							}
																						],
																						"id": 1397,
																						"name": "IndexAccess",
																						"src": "5448:16:2"
																					},
																					{
																						"attributes": {
																							"argumentTypes": null,
																							"overloadedDeclarations": [
																								null
																							],
																							"referencedDeclaration": 1368,
																							"type": "uint256",
																							"value": "equalTokenIssuer"
																						},
																						"id": 1398,
																						"name": "Identifier",
																						"src": "5466:16:2"
																					}
																				],
																				"id": 1399,
																				"name": "FunctionCall",
																				"src": "5417:66:2"
																			}
																		],
																		"id": 1400,
																		"name": "ExpressionStatement",
																		"src": "5417:66:2"
																	},
																	{
																		"children": [
																			{
																				"attributes": {
																					"argumentTypes": null,
																					"isConstant": false,
																					"isLValue": false,
																					"isPure": false,
																					"isStructConstructorCall": false,
																					"lValueRequested": false,
																					"names": [
																						null
																					],
																					"type": "bool",
																					"type_conversion": false
																				},
																				"children": [
																					{
																						"attributes": {
																							"argumentTypes": [
																								{
																									"typeIdentifier": "t_address",
																									"typeString": "address"
																								},
																								{
																									"typeIdentifier": "t_address",
																									"typeString": "address"
																								},
																								{
																									"typeIdentifier": "t_uint256",
																									"typeString": "uint256"
																								}
																							],
																							"isConstant": false,
																							"isLValue": false,
																							"isPure": false,
																							"lValueRequested": false,
																							"member_name": "transferFrom",
																							"referencedDeclaration": 442,
																							"type": "function (address,address,uint256) external returns (bool)"
																						},
																						"children": [
																							{
																								"attributes": {
																									"argumentTypes": null,
																									"overloadedDeclarations": [
																										null
																									],
																									"referencedDeclaration": 1055,
																									"type": "contract EchoLinkToken",
																									"value": "objEchoLink"
																								},
																								"id": 1401,
																								"name": "Identifier",
																								"src": "5501:11:2"
																							}
																						],
																						"id": 1403,
																						"name": "MemberAccess",
																						"src": "5501:24:2"
																					},
																					{
																						"attributes": {
																							"argumentTypes": null,
																							"overloadedDeclarations": [
																								null
																							],
																							"referencedDeclaration": 1309,
																							"type": "address",
																							"value": "from"
																						},
																						"id": 1404,
																						"name": "Identifier",
																						"src": "5526:4:2"
																					},
																					{
																						"attributes": {
																							"argumentTypes": null,
																							"isConstant": false,
																							"isLValue": true,
																							"isPure": false,
																							"lValueRequested": false,
																							"type": "address"
																						},
																						"children": [
																							{
																								"attributes": {
																									"argumentTypes": null,
																									"overloadedDeclarations": [
																										null
																									],
																									"referencedDeclaration": 1303,
																									"type": "address[] memory",
																									"value": "arrayEmployee"
																								},
																								"id": 1405,
																								"name": "Identifier",
																								"src": "5532:13:2"
																							},
																							{
																								"attributes": {
																									"argumentTypes": null,
																									"overloadedDeclarations": [
																										null
																									],
																									"referencedDeclaration": 1382,
																									"type": "uint256",
																									"value": "i"
																								},
																								"id": 1406,
																								"name": "Identifier",
																								"src": "5546:1:2"
																							}
																						],
																						"id": 1407,
																						"name": "IndexAccess",
																						"src": "5532:16:2"
																					},
																					{
																						"attributes": {
																							"argumentTypes": null,
																							"overloadedDeclarations": [
																								null
																							],
																							"referencedDeclaration": 1375,
																							"type": "uint256",
																							"value": "equalTokenRecepient"
																						},
																						"id": 1408,
																						"name": "Identifier",
																						"src": "5550:19:2"
																					}
																				],
																				"id": 1409,
																				"name": "FunctionCall",
																				"src": "5501:69:2"
																			}
																		],
																		"id": 1410,
																		"name": "ExpressionStatement",
																		"src": "5501:69:2"
																	}
																],
																"id": 1411,
																"name": "Block",
																"src": "5399:186:2"
															}
														],
														"id": 1412,
														"name": "ForStatement",
														"src": "5366:219:2"
													}
												],
												"id": 1413,
												"name": "Block",
												"src": "4852:743:2"
											}
										],
										"id": 1414,
										"name": "IfStatement",
										"src": "4645:950:2"
									}
								],
								"id": 1415,
								"name": "Block",
								"src": "4104:1497:2"
							}
						],
						"id": 1416,
						"name": "FunctionDefinition",
						"src": "4021:1580:2"
					},
					{
						"attributes": {
							"constant": true,
							"implemented": true,
							"isConstructor": false,
							"modifiers": [
								null
							],
							"name": "getExperienceResultWhenTrue",
							"payable": false,
							"scope": 1472,
							"stateMutability": "view",
							"superFunction": null,
							"visibility": "public"
						},
						"children": [
							{
								"children": [
									{
										"attributes": {
											"constant": false,
											"name": "_experienceDetails",
											"scope": 1449,
											"stateVariable": false,
											"storageLocation": "default",
											"type": "bytes32",
											"value": null,
											"visibility": "internal"
										},
										"children": [
											{
												"attributes": {
													"name": "bytes32",
													"type": "bytes32"
												},
												"id": 1417,
												"name": "ElementaryTypeName",
												"src": "5644:7:2"
											}
										],
										"id": 1418,
										"name": "VariableDeclaration",
										"src": "5644:26:2"
									},
									{
										"attributes": {
											"constant": false,
											"name": "_experienceYear",
											"scope": 1449,
											"stateVariable": false,
											"storageLocation": "default",
											"type": "uint256",
											"value": null,
											"visibility": "internal"
										},
										"children": [
											{
												"attributes": {
													"name": "uint256",
													"type": "uint256"
												},
												"id": 1419,
												"name": "ElementaryTypeName",
												"src": "5672:7:2"
											}
										],
										"id": 1420,
										"name": "VariableDeclaration",
										"src": "5672:23:2"
									}
								],
								"id": 1421,
								"name": "ParameterList",
								"src": "5643:53:2"
							},
							{
								"children": [
									{
										"attributes": {
											"constant": false,
											"name": "",
											"scope": 1449,
											"stateVariable": false,
											"storageLocation": "default",
											"type": "address[] memory",
											"value": null,
											"visibility": "internal"
										},
										"children": [
											{
												"attributes": {
													"length": null,
													"type": "address[] storage pointer"
												},
												"children": [
													{
														"attributes": {
															"name": "address",
															"type": "address"
														},
														"id": 1422,
														"name": "ElementaryTypeName",
														"src": "5717:7:2"
													}
												],
												"id": 1423,
												"name": "ArrayTypeName",
												"src": "5717:9:2"
											}
										],
										"id": 1424,
										"name": "VariableDeclaration",
										"src": "5717:9:2"
									},
									{
										"attributes": {
											"constant": false,
											"name": "",
											"scope": 1449,
											"stateVariable": false,
											"storageLocation": "default",
											"type": "address[] memory",
											"value": null,
											"visibility": "internal"
										},
										"children": [
											{
												"attributes": {
													"length": null,
													"type": "address[] storage pointer"
												},
												"children": [
													{
														"attributes": {
															"name": "address",
															"type": "address"
														},
														"id": 1425,
														"name": "ElementaryTypeName",
														"src": "5728:7:2"
													}
												],
												"id": 1426,
												"name": "ArrayTypeName",
												"src": "5728:9:2"
											}
										],
										"id": 1427,
										"name": "VariableDeclaration",
										"src": "5728:9:2"
									}
								],
								"id": 1428,
								"name": "ParameterList",
								"src": "5716:22:2"
							},
							{
								"children": [
									{
										"children": [
											{
												"attributes": {
													"argumentTypes": null,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"isStructConstructorCall": false,
													"lValueRequested": false,
													"names": [
														null
													],
													"type": "tuple()",
													"type_conversion": false
												},
												"children": [
													{
														"attributes": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_bool",
																	"typeString": "bool"
																}
															],
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 1977,
															"type": "function (bool) pure",
															"value": "require"
														},
														"id": 1429,
														"name": "Identifier",
														"src": "5749:7:2"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"isConstant": false,
															"isLValue": true,
															"isPure": false,
															"lValueRequested": false,
															"type": "bool"
														},
														"children": [
															{
																"attributes": {
																	"argumentTypes": null,
																	"overloadedDeclarations": [
																		null
																	],
																	"referencedDeclaration": 1081,
																	"type": "mapping(address => bool)",
																	"value": "experienceSet"
																},
																"id": 1430,
																"name": "Identifier",
																"src": "5757:13:2"
															},
															{
																"attributes": {
																	"argumentTypes": null,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"lValueRequested": false,
																	"member_name": "sender",
																	"referencedDeclaration": null,
																	"type": "address"
																},
																"children": [
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"overloadedDeclarations": [
																				null
																			],
																			"referencedDeclaration": 1974,
																			"type": "msg",
																			"value": "msg"
																		},
																		"id": 1431,
																		"name": "Identifier",
																		"src": "5771:3:2"
																	}
																],
																"id": 1432,
																"name": "MemberAccess",
																"src": "5771:10:2"
															}
														],
														"id": 1433,
														"name": "IndexAccess",
														"src": "5757:25:2"
													}
												],
												"id": 1434,
												"name": "FunctionCall",
												"src": "5749:34:2"
											}
										],
										"id": 1435,
										"name": "ExpressionStatement",
										"src": "5749:34:2"
									},
									{
										"attributes": {
											"functionReturnParameters": 1428
										},
										"children": [
											{
												"attributes": {
													"argumentTypes": null,
													"isConstant": false,
													"isInlineArray": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"type": "tuple(address[] storage ref,address[] storage ref)"
												},
												"children": [
													{
														"attributes": {
															"argumentTypes": null,
															"isConstant": false,
															"isLValue": true,
															"isPure": false,
															"lValueRequested": false,
															"type": "address[] storage ref"
														},
														"children": [
															{
																"attributes": {
																	"argumentTypes": null,
																	"isConstant": false,
																	"isLValue": true,
																	"isPure": false,
																	"lValueRequested": false,
																	"type": "mapping(uint256 => address[] storage ref)"
																},
																"children": [
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"overloadedDeclarations": [
																				null
																			],
																			"referencedDeclaration": 1077,
																			"type": "mapping(bytes32 => mapping(uint256 => address[] storage ref))",
																			"value": "mappingArrayOfEmployer"
																		},
																		"id": 1436,
																		"name": "Identifier",
																		"src": "5801:22:2"
																	},
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"overloadedDeclarations": [
																				null
																			],
																			"referencedDeclaration": 1418,
																			"type": "bytes32",
																			"value": "_experienceDetails"
																		},
																		"id": 1437,
																		"name": "Identifier",
																		"src": "5824:18:2"
																	}
																],
																"id": 1438,
																"name": "IndexAccess",
																"src": "5801:42:2"
															},
															{
																"attributes": {
																	"argumentTypes": null,
																	"overloadedDeclarations": [
																		null
																	],
																	"referencedDeclaration": 1420,
																	"type": "uint256",
																	"value": "_experienceYear"
																},
																"id": 1439,
																"name": "Identifier",
																"src": "5844:15:2"
															}
														],
														"id": 1440,
														"name": "IndexAccess",
														"src": "5801:59:2"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"isConstant": false,
															"isLValue": true,
															"isPure": false,
															"lValueRequested": false,
															"type": "address[] storage ref"
														},
														"children": [
															{
																"attributes": {
																	"argumentTypes": null,
																	"isConstant": false,
																	"isLValue": true,
																	"isPure": false,
																	"lValueRequested": false,
																	"type": "mapping(uint256 => address[] storage ref)"
																},
																"children": [
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"overloadedDeclarations": [
																				null
																			],
																			"referencedDeclaration": 1070,
																			"type": "mapping(bytes32 => mapping(uint256 => address[] storage ref))",
																			"value": "mappingArrayOfEmployee"
																		},
																		"id": 1441,
																		"name": "Identifier",
																		"src": "5879:22:2"
																	},
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"overloadedDeclarations": [
																				null
																			],
																			"referencedDeclaration": 1418,
																			"type": "bytes32",
																			"value": "_experienceDetails"
																		},
																		"id": 1442,
																		"name": "Identifier",
																		"src": "5902:18:2"
																	}
																],
																"id": 1443,
																"name": "IndexAccess",
																"src": "5879:42:2"
															},
															{
																"attributes": {
																	"argumentTypes": null,
																	"overloadedDeclarations": [
																		null
																	],
																	"referencedDeclaration": 1420,
																	"type": "uint256",
																	"value": "_experienceYear"
																},
																"id": 1444,
																"name": "Identifier",
																"src": "5922:15:2"
															}
														],
														"id": 1445,
														"name": "IndexAccess",
														"src": "5879:59:2"
													}
												],
												"id": 1446,
												"name": "TupleExpression",
												"src": "5800:139:2"
											}
										],
										"id": 1447,
										"name": "Return",
										"src": "5793:146:2"
									}
								],
								"id": 1448,
								"name": "Block",
								"src": "5739:207:2"
							}
						],
						"id": 1449,
						"name": "FunctionDefinition",
						"src": "5607:339:2"
					},
					{
						"attributes": {
							"constant": false,
							"implemented": true,
							"isConstructor": false,
							"modifiers": [
								null
							],
							"name": "setExperienceToFalse",
							"payable": false,
							"scope": 1472,
							"stateMutability": "nonpayable",
							"superFunction": null,
							"visibility": "public"
						},
						"children": [
							{
								"attributes": {
									"parameters": [
										null
									]
								},
								"children": [],
								"id": 1450,
								"name": "ParameterList",
								"src": "5981:2:2"
							},
							{
								"attributes": {
									"parameters": [
										null
									]
								},
								"children": [],
								"id": 1451,
								"name": "ParameterList",
								"src": "5991:0:2"
							},
							{
								"children": [
									{
										"children": [
											{
												"attributes": {
													"argumentTypes": null,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"isStructConstructorCall": false,
													"lValueRequested": false,
													"names": [
														null
													],
													"type": "tuple()",
													"type_conversion": false
												},
												"children": [
													{
														"attributes": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_bool",
																	"typeString": "bool"
																}
															],
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 1977,
															"type": "function (bool) pure",
															"value": "require"
														},
														"id": 1452,
														"name": "Identifier",
														"src": "6001:7:2"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"isConstant": false,
															"isLValue": true,
															"isPure": false,
															"lValueRequested": false,
															"type": "bool"
														},
														"children": [
															{
																"attributes": {
																	"argumentTypes": null,
																	"overloadedDeclarations": [
																		null
																	],
																	"referencedDeclaration": 1081,
																	"type": "mapping(address => bool)",
																	"value": "experienceSet"
																},
																"id": 1453,
																"name": "Identifier",
																"src": "6009:13:2"
															},
															{
																"attributes": {
																	"argumentTypes": null,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"lValueRequested": false,
																	"member_name": "sender",
																	"referencedDeclaration": null,
																	"type": "address"
																},
																"children": [
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"overloadedDeclarations": [
																				null
																			],
																			"referencedDeclaration": 1974,
																			"type": "msg",
																			"value": "msg"
																		},
																		"id": 1454,
																		"name": "Identifier",
																		"src": "6023:3:2"
																	}
																],
																"id": 1455,
																"name": "MemberAccess",
																"src": "6023:10:2"
															}
														],
														"id": 1456,
														"name": "IndexAccess",
														"src": "6009:25:2"
													}
												],
												"id": 1457,
												"name": "FunctionCall",
												"src": "6001:34:2"
											}
										],
										"id": 1458,
										"name": "ExpressionStatement",
										"src": "6001:34:2"
									},
									{
										"children": [
											{
												"attributes": {
													"argumentTypes": null,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"operator": "=",
													"type": "bool"
												},
												"children": [
													{
														"attributes": {
															"argumentTypes": null,
															"isConstant": false,
															"isLValue": true,
															"isPure": false,
															"lValueRequested": true,
															"type": "bool"
														},
														"children": [
															{
																"attributes": {
																	"argumentTypes": null,
																	"overloadedDeclarations": [
																		null
																	],
																	"referencedDeclaration": 1081,
																	"type": "mapping(address => bool)",
																	"value": "experienceSet"
																},
																"id": 1459,
																"name": "Identifier",
																"src": "6045:13:2"
															},
															{
																"attributes": {
																	"argumentTypes": null,
																	"isConstant": false,
																	"isLValue": false,
																	"isPure": false,
																	"lValueRequested": false,
																	"member_name": "sender",
																	"referencedDeclaration": null,
																	"type": "address"
																},
																"children": [
																	{
																		"attributes": {
																			"argumentTypes": null,
																			"overloadedDeclarations": [
																				null
																			],
																			"referencedDeclaration": 1974,
																			"type": "msg",
																			"value": "msg"
																		},
																		"id": 1460,
																		"name": "Identifier",
																		"src": "6059:3:2"
																	}
																],
																"id": 1461,
																"name": "MemberAccess",
																"src": "6059:10:2"
															}
														],
														"id": 1462,
														"name": "IndexAccess",
														"src": "6045:25:2"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"hexvalue": "66616c7365",
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"subdenomination": null,
															"token": "bool",
															"type": "bool",
															"value": "false"
														},
														"id": 1463,
														"name": "Literal",
														"src": "6073:5:2"
													}
												],
												"id": 1464,
												"name": "Assignment",
												"src": "6045:33:2"
											}
										],
										"id": 1465,
										"name": "ExpressionStatement",
										"src": "6045:33:2"
									},
									{
										"children": [
											{
												"attributes": {
													"argumentTypes": null,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"isStructConstructorCall": false,
													"lValueRequested": false,
													"names": [
														null
													],
													"type": "tuple()",
													"type_conversion": false
												},
												"children": [
													{
														"attributes": {
															"argumentTypes": [
																{
																	"typeIdentifier": "t_stringliteral_be92e5c5a48856a35d428121e9a9966385cf6a7704918385a305255f06cc61a2",
																	"typeString": "literal_string \"experience set to false\""
																}
															],
															"overloadedDeclarations": [
																null
															],
															"referencedDeclaration": 1099,
															"type": "function (string memory)",
															"value": "Executed"
														},
														"id": 1466,
														"name": "Identifier",
														"src": "6088:8:2"
													},
													{
														"attributes": {
															"argumentTypes": null,
															"hexvalue": "657870657269656e63652073657420746f2066616c7365",
															"isConstant": false,
															"isLValue": false,
															"isPure": true,
															"lValueRequested": false,
															"subdenomination": null,
															"token": "string",
															"type": "literal_string \"experience set to false\"",
															"value": "experience set to false"
														},
														"id": 1467,
														"name": "Literal",
														"src": "6097:25:2"
													}
												],
												"id": 1468,
												"name": "FunctionCall",
												"src": "6088:35:2"
											}
										],
										"id": 1469,
										"name": "ExpressionStatement",
										"src": "6088:35:2"
									}
								],
								"id": 1470,
								"name": "Block",
								"src": "5991:139:2"
							}
						],
						"id": 1471,
						"name": "FunctionDefinition",
						"src": "5952:178:2"
					}
				],
				"id": 1472,
				"name": "ContractDefinition",
				"src": "106:6026:2"
			}
		],
		"id": 1473,
		"name": "SourceUnit",
		"src": "0:6132:2"
	},
	"compiler": {
		"name": "solc",
		"version": "0.4.18+commit.9cf6e910.Emscripten.clang"
	},
	"networks": {
		"4": {
			"events": {},
			"links": {},
			"address": "0xff3b263b25f540a9df1a1247d8430031df365ed3"
		}
	},
	"schemaVersion": "1.0.1",
	"updatedAt": "2018-02-22T12:09:06.982Z"
};


//////////////////
// WEBPACK FOOTER
// ./build/contracts/ExperienceStore.json
// module id = 72
// module chunks = 0